import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input,HostListener, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { NotificationService } from '../service/notification.service';
import { fieldsByComponent,unitList,schemeLists,componentLists,apoObject,historyObj } from '../model/fields';
import { APOResponse, APOTask, FieldDefinition, TableRow, SavedData, ComponentFields, APORequest, SiteData } from '../model/interfaces';
import { HttpClient,HttpBackend } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { ApogeometrymapviewComponent } from '../apogeometrymapview/apogeometrymapview.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { kml } from 'togeojson';
import {  GeoJSON, KML } from 'ol/format';
import { tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';


declare var jQuery: any;
const baseUrlFile = environment.FILE_API_URL;


@Component({
  selector: 'app-aporeport',
  templateUrl: './aporeport.component.html',
  styleUrls: ['./aporeport.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush // 🚀 Optimized Change Detection
})
export class AporeportComponent implements OnInit,AfterViewInit {
  apoRequest: APORequest | null = null;
  isReadOnly: boolean = false;
  yearRange: string = '';
  
  executionForm: FormGroup;
  siteSpecificationFilterForm: FormGroup;
  apoForm!:FormGroup;
  siteSpecificationForm: FormGroup;
  fieldsByComponent : ComponentFields = fieldsByComponent;
  unitList : any = unitList;

  finYearList: any=[];
  schemeList: any=[];
  subSchemeList: any=[];
  componentList: any= [];
  dynamicFields: any[] = [];
  tableData: any[]=[];
  private initialTableData: TableRow[] = [];
  dynamicColumns: string[] = []; 

  formTitle: any="";
  formDesc: any="";
  selectedComponent: string | null = null;
  reportName: string | null = null;

  tableHeaders: string[] = [];
  structuredData: any[] = [];
  
  headerRows: { superGroup: any[]; group: any[]; label: any[]; };
  
  selectedRow: TableRow | null = null;
  modalForm: FormGroup;
  isModalOpen = false;
  savedData: SavedData = { rows: [], additionalInfo: {} };
  taskForms: FormArray;
  allRowsSaved: boolean = false;
  isErrorInSitesSubmitted: boolean = false;
  maxRows: number = 60;

  currentScheme: any = null;
  currentComponent: any = null;
  originalData: APOResponse | null = null;

  private inputTypes = {
    'text': 'text',
    'number': 'number',
    'dd': 'dropdown'
  };
  isLoading: boolean = false;
  isInitialized: boolean = false;
  isFormReady: boolean = false;
  private previousSchemeId: string | null = '0'; // Add property to track previous scheme
  private previousComponentId: string | null = '0'; // Add property to track previous scheme
  userid: any;
  private  apoJsonValuesMap: Map<number, { [key: string]: string | null }> = new Map();

  openPanels = { view: false, execution: false, map: true };
  activeTab: string = 'kml';
  mapinfo: any[]=[];
  mapPreviewGeojsonInfo:{ geojson: string, geojsonProps: string } | undefined;
  kmlinfo:any;

  executionList: any;
  
  executionTotalItems: number = 0;
  executionTotalPages: number = 0;
  executionCurrentPage =1;
  executionPageSize = 10;
  executionPagesArray: number[] = [];
  executionFilteredData: any[]=[];
  executionFilterResult: any[]=[];
  executionPaginatedData: any[] = [];

  selectedImagePath: string;
  isImageModalOpen: boolean=false;

  isMapModalOpen: boolean=false;
  // @ViewChild(ApogeometrymapviewComponent) mapView: ApogeometrymapviewComponent;
  apoIdItemNameList: { mapId: any; itemName: any; }[];
  typeListform: { mapId: any;typeId:any; ddValue: any; }[];
  isViewMode: boolean;
  //filteredApoIdItemNameList: { apoId: any; itemName: any; }[];

  pointlat: number | null = 20.3351866;
  pointlon: number | null = 85.7980446;

  beforeImagePreview: string | null = null;
  afterImagePreview: string | null = null;
  private pdfBlobUrl: string | null = null;     // actual blob URL string
  pdfPreviewUrl: SafeResourceUrl | null = null;

   // Store File objects in component properties
  kmlFile: File | null = null;
  beforeImageFile: File | null = null;
  afterImageFile: File | null = null;
  pdfFile: File | null = null;
  geojsonstring: string;
  geojsonprops: string;

  geoTagImgCoord: { latitude: number, longitude: number } | undefined;
  geoTagBeforeImgCoord: { latitude: number, longitude: number } | undefined;
  geoTagAfterImgCoord: { latitude: number, longitude: number } | undefined;

  filesList:any[]=[];
  ddListsform:any[]=[];
  currentRow: TableRow | null = null;
  isModalSiteSpecificationOpen: boolean=false;

  wordCount = 0;
  siteImages: { file: File, previewUrl: string, coordinates?: { latitude: number, longitude: number } }[] = [];
  tempSiteImage: File | null = null;
  tempSiteImagePreview: string | null = null;
  tempSiteImageCoordinates: { latitude: number, longitude: number } | null = null;
  supportiveDocumentPreviewUrl: SafeResourceUrl | null = null;
  supportiveDocumentBlobUrl: string | null = null;
  supportiveDocumentFile: File | null = null;
  charCount=0;
  documentTypeLists: any[]=[];
  
  sites: SiteData[] = [];
  apoSiteIdList: any[]=[];
  apoSiteRemarksList: any[]=[];

  isUploadExcelModalOpen :boolean = false;
  selectedExcelFile: File | null = null;
  previousMajorSchemeId: any;

  constructor(
    private fb: FormBuilder,
    private notifyService: NotificationService,
    private apiService: ApiService, 
    private cdr: ChangeDetectorRef,
    private readonly route:ActivatedRoute,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) { 
    const userdata=sessionStorage.getItem('user');
    if(userdata!=null){
      const user=JSON.parse(userdata);
      this.userid=user.userid;
    }
    this.getAllSchemeDD();
    this.getAllDocumentType();
    // const state = history.state;
    // //console.log(state);
    // this.apoRequest = state?.apoRequest || null;
    // this.isReadOnly = state?.isReadOnly || false;
    // this.apoRequest = historyObj?.apoRequest || null;
    // this.isReadOnly = historyObj?.isReadOnly || false;
    this.route.paramMap.subscribe(params => {
      const formId = params.get('formId');
      const componentId = params.get('componentId');
      this.route.queryParams.subscribe(query => {
        this.isViewMode = query['mode'] === 'view';
        this.isReadOnly = this.isViewMode || this.isReadOnly;
        if(this.isViewMode)
        this.getValueFormList(componentId,formId);
      });
    });
     
    this.taskForms = this.fb.array([]);
    this.apoForm = this.fb.group({
      scheme: ["0", Validators.required],
       subscheme: ["0", Validators.required],
      component: ["0", Validators.required]
    });
    this.modalForm = this.fb.group({
      remarks: ['', [Validators.maxLength(300)]],
      kmlFile: [null],
      beforeImage: [null],
      afterImage: [null],
      pdfFile: [null]
    });
    this.executionForm = this.fb.group({
      kmlFile: [null],
      beforeImage: [null],
      afterImage: [null],
      planFile: [null],
      dprFile: [null],
      tenderFile: [null],
      workOrderFile: [null],
      completionFile: [null]
    });
    this.siteSpecificationFilterForm= this.fb.group({
      mapId:[''],
      typeId:[''],
      documentTypeId: [''],
      fromDate: [''],
      toDate: ['']
    });
    this.siteSpecificationForm = this.fb.group({
      remarks: [''],
      supportiveDocument: [null]
    });
  } 
  
  ngAfterViewInit() {
    // Listen for Bootstrap's modal shown event
    // $('#mapModal').on('shown.bs.modal', () => {
    //   if (this.mapView) {
    //     this.mapView.resizeMap();
    //   }
    // });
  }
  ngOnDestroy(): void {
    // Clean up object URLs to prevent memory leaks
    if (this.beforeImagePreview) {
      URL.revokeObjectURL(this.beforeImagePreview);
    }
    if (this.afterImagePreview) {
      URL.revokeObjectURL(this.afterImagePreview);
    }
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
    }
  }
  ngOnInit(): void {
     const currentYear = new Date().getFullYear();
    this.yearRange = `${currentYear}-${currentYear + 1}`;
    
    if (!this.isViewMode) {    
      this.openPanels = { view: true, execution: false, map: false };
     // this.filteredApoIdItemNameList = [...this.apoIdItemNameList];
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges()) {
      // Set a message to trigger the browser's confirmation dialog
      event.preventDefault();
      ////console.log("onBeforeUnload");

      event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
    }
  }
  getValueFormList(componentId: any,formId:any): void {
   
    const params = `componentId=${componentId}&formId=${formId}`;
    this.apiService.request('GET', `api/v1/APO/ViewAllReportFormDetails?${params}`).subscribe({
      next: (response: any) => {
        //console.log(response);
        if (response && response.length > 0) {
          this.apoRequest = response[0]; // Select first item (adjust if needed)
          ////console.log('View API Response:', this.apoRequest);
          this.getApoExecutionDD();
          this.bindApoRequest();
          
        } else {
          this.notifyService.showError('No form details found', 'Error');
        }
      },
      error: (error) => {
        console.error('Error fetching form details:', error);
        this.notifyService.showError('Error fetching form details', 'Error');
      }
    });
  }
 bindApoRequest(): void {
   if (this.apoRequest) {
     this.apoForm.patchValue({
       scheme: this.apoRequest.schemeId?.toString() || '0'
     });
     this.formTitle = this.apoRequest.reportName || 'Annual Plan of Operation';
     this.formDesc = this.apoRequest.about || '';
     this.getAllComponentDDByScheme(this.apoRequest.schemeId.toString());
     this.apoForm.patchValue({
       component: this.apoRequest.componentId?.toString() || '0'
     });
    // this.onSelectComponent(this.apoRequest.componentId);
    // Populate apoJsonValuesMap    
    this.apoJsonValuesMap.clear();
    const processTasks = (tasks: APOTask[], level: number = 0) => {
     tasks.forEach(task => {
       //const taskId = Number(`${task.mapId}${task.taskId}`);
       const taskId = Number(task.mapId); // Normalize to number
       this.apoJsonValuesMap.set(taskId, task.apoValueResponse || {});
      
       if (task.apoTypeWiseValues && task.apoTypeWiseValues.length > 0) {
        task.apoTypeWiseValues.forEach(type => {
          type.apoValueResponses.forEach((response: any, index: number) => {
            const syntheticTaskId = Number(`${taskId}${type.typeId}${index}`);
            this.apoJsonValuesMap.set(syntheticTaskId, response);
          });
        });
       }

       if (task.subTaskList && task.subTaskList.length > 0) {
         processTasks(task.subTaskList, level + 1);
       }
     });
    };
     ////console.log(this.apoJsonValuesMap)
    if (this.apoRequest.taskList) {
     processTasks(this.apoRequest.taskList);
     this.onSelectComponent(this.apoRequest!.componentId.toString());
     if (this.isReadOnly) {
       this.apoForm.disable();
     }
   } else {
     console.warn('bindApoRequest: No taskList found in apoRequest');
   }
  // //console.log("tasklist", this.apoRequest.taskList)
   // Collect coordinates and store in mapinfo
   //this.mapinfo = this.collectCoordinates(this.apoRequest.taskList,this.apoRequest.formId,this.apoRequest.componentId);
  
   this.getAPOSiteJustificationList();

   } else {
     console.error('bindApoRequest: No apoRequest found');
   }
 }
 private collectGeometry():any[]{
  const geoJson: any[] = [];
   const processGeometry = (data) => {
        geoJson.push({
          geoJson	:data.geoJson,
          propertyGeoJson	:data.propertyGeoJson,	
          apoSiteId:data.apoSiteId,
          apoId: data.apoId,
          mapId:data.componentId,
          formId:this.apoRequest.formId,
          componentId:this.apoRequest.componentId
        });
  };
    this.executionFilterResult.forEach(geom => processGeometry(geom));
  return geoJson;
 }
 private collectCoordinates(tasks: APOTask[],formId:any, componentId:any): any[] {
  const coordinates: any[] = [];

  const processTask = (task: APOTask, parentName: string = '') => {
    const taskName = task.taskName;
    const fullTaskName = parentName ? `${parentName} > ${taskName}` : taskName;

    // Check apoValueResponse for coordinates
    if (task.apoValueResponse) {
      const lat = this.dmsToDecimal(task.apoValueResponse.gpsdd1, task.apoValueResponse.gpsmm1, task.apoValueResponse.gpsss1);
      const lon = this.dmsToDecimal(task.apoValueResponse.gpsdd2, task.apoValueResponse.gpsmm2, task.apoValueResponse.gpsss2);
      if (lat !== null && lon !== null && task.apoValueResponse.location) {
        coordinates.push({
          lat,
          lon,
          taskName: fullTaskName,
          typeName: null,
          location: task.apoValueResponse.location,
          apoId: task.apoId,
          mapId:task.mapId,
          formId:formId,
          componentId:componentId
        });
      }
    }

    // Check apoTypeWiseValues for coordinates
    if (task.apoTypeWiseValues && task.apoTypeWiseValues.length > 0) {
      task.apoTypeWiseValues.forEach(type => {
        type.apoValueResponses.forEach((response: any) => {
          const lat = this.dmsToDecimal(response.gpsdd1, response.gpsmm1, response.gpsss1);
          const lon = this.dmsToDecimal(response.gpsdd2, response.gpsmm2, response.gpsss2);
          if (lat !== null && lon !== null && response.location) {
            coordinates.push({
              lat,
              lon,
              taskName: fullTaskName,
              typeName: type.typeName?.trim(),
              location: response.location,
               apoId: task.apoId,
              mapId:task.mapId,
              formId:formId,
              componentId:componentId
            });
          }
        });
      });
    }

    // Recursively process sub-tasks
    if (task.subTaskList && task.subTaskList.length > 0) {
      task.subTaskList.forEach(subTask => processTask(subTask, fullTaskName));
    }
  };

  tasks.forEach(task => processTask(task));
  return coordinates;
}
 // Convert DMS (Degrees, Minutes, Seconds) to Decimal Degrees
 private dmsToDecimal(degrees: string | null, minutes: string | null, seconds: string | null): number | null {
  const deg = parseFloat(degrees || '0');
  const min = parseFloat(minutes || '0');
  const sec = parseFloat(seconds || '0');
  if (isNaN(deg)) return null;
  return deg + (min / 60) + (sec / 3600);
}
 getAllSchemeDD() {
   //this.schemeList=schemeLists;
     this.apiService.request('GET', 'api/v1/APO/getAllSchemeDD').subscribe((data: any) => {
      if (data) {
        this.schemeList = data;
        this.subSchemeList=[];
        this.componentList=[];
        this.resetFormState();
        this.apoForm.get('subscheme')?.setValue('0');
        this.apoForm.get('component')?.setValue('0');
      }
    });
} 
 getAllSubSchemeDD(schemeId:any) {
      if (this.hasSavedRows()) {
        this.notifyService.showWarning('Please submit data before changing major scheme', 'Warning');
          this.apoForm.get('scheme')?.setValue(this.previousMajorSchemeId, { emitEvent: false }); // Revert to previous scheme
        //this.cdr.markForCheck();
        return;
      }
      this.previousMajorSchemeId = schemeId; // Update previous scheme ID


     this.apiService.request('GET', `api/v1/APO/getAllSubSchemeDD?schemeId=${Number(schemeId)}`).subscribe(
     (data: any) => {
       this.isLoading = false;
       if (data && Array.isArray(data)) {
         this.subSchemeList = data;
         this.componentList=[];
         
      this.resetFormState();
        this.apoForm.get('subscheme')?.setValue('0');
        this.apoForm.get('component')?.setValue('0');
        this.apoForm.get('component')?.enable();
         ////console.log(this.subSchemeList)
       } 
       this.isInitialized = true;
       ////this.cdr.markForCheck();
     },
     (error) => {
       this.isLoading = false;
       this.isInitialized = true;
       this.notifyService.showError('Failed to load scheme', 'Error');
       //this.cdr.markForCheck();
     }
   );
   //this.componentList=componentLists;
  }
  getAllComponentDDByScheme(schemeId: string) {
   if (this.hasSavedRows()) {
     this.notifyService.showWarning('Please submit data before changing scheme', 'Warning');
       this.apoForm.get('subscheme')?.setValue(this.previousSchemeId, { emitEvent: false }); // Revert to previous scheme
     //this.cdr.markForCheck();
     return;
   }

   this.previousSchemeId = schemeId; // Update previous scheme ID


   if (!schemeId || schemeId === '0') {
     this.componentList = [];
     this.apoForm.get('component')?.setValue('0');
     this.resetFormState();
     return;
   }
  
   this.resetFormState();
   this.apiService.request('GET', `api/v1/APO/getAllComponentDDByScheme?schemeId=${schemeId}`).subscribe(
     (data: any) => {
       this.isLoading = false;
       if (data && Array.isArray(data)) {
         this.componentList = data;
            ////console.log(this.componentList);
        if(this.componentList.length==1 ){
          ////console.log(this.componentList);
          this.apoForm.get('component')?.setValue(this.componentList[0].id);
           this.apoForm.get('component')?.disable();
          this.onSelectComponent(this.componentList[0].id);
        }else{
           this.apoForm.get('component')?.enable();
        }
        // //console.log(this.componentList)
       } else {
         this.notifyService.showWarning('No components available', 'Warning');
       }
       this.isInitialized = true;
       //this.cdr.markForCheck();
     },
     (error) => {
       this.isLoading = false;
       this.isInitialized = true;
       this.notifyService.showError('Failed to load components', 'Error');
       //this.cdr.markForCheck();
     }
   );
   //this.componentList=componentLists;
  }
 private resetFormState() {
   this.tableData = [];
   this.taskForms.clear();
   this.dynamicFields = [];
   this.dynamicColumns = [];
   this.isInitialized = false;
   this.isFormReady = false;
   this.formTitle = '';
   this.formDesc = '';
   this.originalData = null;
    
   //this.cdr.markForCheck();
 }
  //************************************************************ */
  getApoExecutionDD(){
    this.apiService.request('GET', 'api/v1/APO/getApoExecutionDD').subscribe((data: any) => {
      if (data) {
        this.executionList = data;
       // //console.log("Execution list",this.executionList);
      }
    });
  }
  getAPOSiteJustificationList() : void{
    ////console.log(this.siteSpecificationFilterForm.value)
    if(this.typeListform?.length==0)
    {

            this.siteSpecificationFilterForm.patchValue({
               typeId: ''
             });
    }
    const params: string[] = [];

    if (this.apoRequest.formId) params.push(`formId=${this.apoRequest.formId}`);
    if (this.apoRequest.componentId) params.push(`componentId=${this.apoRequest.componentId}`);
    if (this.siteSpecificationFilterForm.value.mapId!="") params.push(`mapId=${this.siteSpecificationFilterForm.value.mapId}`);
    if (this.siteSpecificationFilterForm.value.typeId!="") params.push(`typeId=${this.siteSpecificationFilterForm.value.typeId}`);
    // if (this.siteSpecificationFilterForm.value.circle) params.push(`circleId=${this.siteSpecificationFilterForm.value.circle}`);
    // if (this.siteSpecificationFilterForm.value.division) params.push(`divId=${this.siteSpecificationFilterForm.value.division}`);
    // if (this.siteSpecificationFilterForm.value.range) params.push(`rangeId=${this.siteSpecificationFilterForm.value.range}`);
    if (this.siteSpecificationFilterForm.value.documentTypeId!="") params.push(`documentTypeId=${this.siteSpecificationFilterForm.value.documentTypeId}`);
    if (this.siteSpecificationFilterForm.value.fromDate) params.push(`startDate=${this.siteSpecificationFilterForm.value.fromDate}`);
    if (this.siteSpecificationFilterForm.value.toDate) params.push(`endDate=${this.siteSpecificationFilterForm.value.toDate}`);

    // Optional: Add pagination default
    params.push(`page=0`);
    params.push(`size=10`);
  
    const queryString = params.join('&');
  ////console.log(queryString);
    this.apiService.request('GET', `api/v1/APO/getAPOSiteJustificationList?${queryString}`).subscribe({
      next: (response: any) => {
        if (response.status === 1) {
        //  //console.log("getAPOExecutionList",response);
          this.executionFilterResult = response.data.data || [];
          this.mapinfo=this.collectGeometry();
          this.executionTotalItems = response.data.totalItems || 0;
          this.executionTotalPages = response.data.totalPages || 1;
          this.executionCurrentPage = 1;
          this.executionFilteredData = []; // Reset any old search
          this.executionSetupPagination();
        } else {
          this.notifyService.showError("Error fetching filter options", "Error");
        }
      },
      error: (error) => {//console.error('Error :', error)
        }
    });
  }
  executionSetupPagination() {
  const dataSource = this.executionFilteredData.length > 0 ? this.executionFilteredData : this.executionFilterResult;
  this.executionTotalItems = dataSource.length;
  this.executionTotalPages = Math.ceil(this.executionTotalItems / this.executionPageSize);
  this.executionPagesArray = Array.from({ length: this.executionTotalPages }, (_, i) => i + 1);

  const start = (this.executionCurrentPage - 1) * this.executionPageSize;
  const end = start + this.executionPageSize;
  this.executionPaginatedData = dataSource.slice(start, end);
  }
  applyExecutionFilter(){
    this.getAPOSiteJustificationList();
  }
  resetExecutionFilters(){
    this.siteSpecificationFilterForm= this.fb.group({
      mapId:[''],
      typeId:[''],
      documentTypeId: [''],
      fromDate: [''],
      toDate: ['']
    });
    //this.filteredApoIdItemNameList = [...this.apoIdItemNameList];
    this.getAPOSiteJustificationList();
  }
  // filterApoItems(event: Event): void {
  //   const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
  //   this.filteredApoIdItemNameList = this.apoIdItemNameList.filter(apo =>
  //     apo.itemName.toLowerCase().includes(searchTerm)
  //   );
  // }
  changePage(page: number) {
    if (page >= 1 && page <= this.executionTotalPages) {
      this.executionCurrentPage = page;
      this.executionSetupPagination();
    }
  }
  DownloadFile(item:any) :void{
      window.open(baseUrlFile+item.documentPath, '_blank');
  }
  viewSiteDocument(item:any) :void{
    if (item.docTypeId === 1) {
     // this.loadKml.emit(item.documentPath);
     // this.showPanel('map');
     //window.open(baseUrlFile+item.documentPath, '_blank');
     if(item.geoJson)
     this.mapPreviewGeojsonInfo={
      geojson: item.geoJson,
      geojsonProps:item.propertyGeoJson
     }
     this.isMapModalOpen = true;
     // Fetch the KML file as a Blob and convert to File
    //  setTimeout(() => {
    //   if (this.mapView) {
    //     this.mapView.initiatemap(); // Reinitialize map
    //   }
    // }, 300);
      //this.cdr.markForCheck();
    } 
    else if (item.docTypeId === 2 || item.docTypeId === 3) {
      this.selectedImagePath = baseUrlFile+item.documentPath;
      this.isImageModalOpen = true;
    } else  {
      window.open(baseUrlFile+item.documentPath, '_blank');
    }
  }
    // Method to download the execution list as Excel
  downloadExecutionListAsExcel() {
    // Prepare the data for export (using tableData as the "List of Records")
    const exportData = this.executionPaginatedData.map(item => ({
      DocumentTypeName: item.documentTypeName || 'N/A',
      Location: item.location || 'N/A',
      Latitude: item.latitude || 'N/A',
      Longitude: item.longitude || 'N/A',
      Remarks: item.remarks || 'N/A',
      ReportedBy: item.createdBy || 'N/A',
      creationDate: item.creationDate  || 'N/A'
    }));
 
    // Create a worksheet from the data
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Execution List');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `Execution_List.xlsx`);
  }
  closeImageModal(): void {
    this.isImageModalOpen = false;
    this.selectedImagePath = null;
    //this.cdr.markForCheck();
  }
  closeMapModal(): void {
    this.isMapModalOpen = false;
    //this.cdr.markForCheck();
  }
  //************************************************************ */

   // Field definition helper
  getFieldDefinition(fieldName: string): FieldDefinition {
    return this.dynamicFields.find(f => f.name === fieldName) || 
           { name: fieldName, label: fieldName, editable: true, type: 'text' };
  }
  // Input type helper
  getInputType(field: FieldDefinition): string {
    return this.inputTypes[field.type || 'text'] || 'text';
  }
  getHeaderGroups(): { type: string; name: string; fields: any[]; subGroups?: { name: string | null; fields: any[] }[] }[] {
    const result: { type: string; name: string; fields: any[]; subGroups?: { name: string | null; fields: any[] }[] }[] = [];
    let currentSuperGroup: string | null = null;
    let currentSubGroup: string | null = null;
    let superGroupEntry: any | null = null;
    let subGroupEntry: { name: string | null; fields: any[] } | null = null;
  
    for (const field of this.dynamicFields) {
      if (field.superGroup === null && field.group === null) {
        result.push({ type: 'standalone', name: field.label, fields: [field] });
        currentSuperGroup = null;
        superGroupEntry = null;
        subGroupEntry = null;
      } else {
        const effectiveSuperGroup = field.superGroup || field.group;
        if (effectiveSuperGroup !== currentSuperGroup) {
          currentSuperGroup = effectiveSuperGroup;
          superGroupEntry = { type: 'superGroup', name: currentSuperGroup!, subGroups: [] };
          result.push(superGroupEntry);
          currentSubGroup = field.group === effectiveSuperGroup ? null : field.group;
          if (currentSubGroup) {
            subGroupEntry = { name: currentSubGroup, fields: [] };
            superGroupEntry.subGroups!.push(subGroupEntry);
          } else {
            subGroupEntry = { name: null, fields: [] };
            superGroupEntry.subGroups!.push(subGroupEntry);
          }
          subGroupEntry.fields.push(field);
        } else {
          if (field.group !== currentSubGroup && field.group !== effectiveSuperGroup) {
            currentSubGroup = field.group;
            if (currentSubGroup) {
              subGroupEntry = { name: currentSubGroup, fields: [] };
              superGroupEntry!.subGroups!.push(subGroupEntry);
            } else {
              subGroupEntry = { name: null, fields: [] };
              superGroupEntry!.subGroups!.push(subGroupEntry);
            }
          }
          subGroupEntry!.fields.push(field);
        }
      }
    }
  
    return result;
  }
  calculateTotalFields(group: any): number {
    if (group.type === 'superGroup' && group.subGroups) {
      return group.subGroups.reduce((total: number, subGroup: any) => total + subGroup.fields.length, 0);
    }
    return group.fields.length;
  }
  //******************************************************************************** */
 
onSelectComponent(selectedComponentId: any) {

  if (this.hasSavedRows()) {
    this.notifyService.showWarning('Please submit data before changing component', 'Warning');
    this.apoForm.get('component')?.setValue(this.previousComponentId, { emitEvent: false });
    //this.cdr.markForCheck();
    return;
  }

  this.previousComponentId = selectedComponentId;
  
  if (!selectedComponentId || selectedComponentId === '0') {
    this.resetFormState();
    return;
  }

  this.selectedComponent = selectedComponentId;
  this.currentComponent = this.componentList.find(c => c.id === selectedComponentId);
  this.currentScheme = this.schemeList.find(s => s.id === this.apoForm.get('scheme')?.value);

  this.resetFormState();
  this.dynamicFields = this.fieldsByComponent[selectedComponentId] || [];
 ////console.log("dynamicFields", this.dynamicFields)
    // Dynamically filter out 'site' field in view mode
    if (this.isViewMode) {
     // this.dynamicFields = this.dynamicFields.filter(field => field.name.toLowerCase() !== 'site');
      this.dynamicFields = this.dynamicFields.filter(field => !['site', 'justification'].includes(field.name.toLowerCase()));
    }

  // Dynamically compute expectedFields
  const expectedFields = this.fieldsByComponent[selectedComponentId]
    ? this.fieldsByComponent[selectedComponentId]
        .filter(field => field.editable)
        .map(field => field.name)
    : [];
  
  // Validate requiredFields against expectedFields
  const requiredFields = this.dynamicFields
    .filter(field => field.editable)
    .map(field => field.name);

  if (!requiredFields.length) {
    this.notifyService.showWarning('No editable fields defined for selected component', 'Warning');
    return;
  }

  this.dynamicColumns = requiredFields;
  
 // //console.log("dynamicColumns", this.dynamicColumns )

  if (!this.dynamicFields.length) {
    this.notifyService.showWarning('No fields defined for selected component', 'Warning');
    return;
  }

  if (selectedComponentId && this.fieldsByComponent[selectedComponentId]) {
    const component = this.componentList.find(c => c.id === selectedComponentId);
    this.reportName = component ? component.reportName : null;
    this.formDesc = component ? component.about || '' : '';
  }
 // this.loadReportFormDetails(selectedComponentId);
  if(this.apoRequest){
     this.processHierarchicalData(this.apoRequest.taskList)
  }else{
    this.loadReportFormDetails(selectedComponentId);
  }
}

//************ Excel Uplaod ******************************************************** */
// Export tableData as CSV
  private downloadAsCsv(): void {
    // Define CSV headers
    const headers = ['Serial', 'Item Name', ...this.dynamicFields.map(field => field.label)];
    const csvRows: string[] = [headers.join(',')];

    // Process each row in tableData
    this.tableData.forEach(row => {
      const indent = '  '.repeat(row.level); // Indent based on hierarchy level
      const itemName = `${indent}${this.cleanItemName(row.itemName)}`;
      const serial = row.serial || '';

      // Extract dynamic field values
      const fieldValues = this.dynamicFields.map(field => {
        const value = row.data[field.name] || '';
        // Escape commas and quotes in the value
        return `"${String(value).replace(/"/g, '""')}"`;
      });

      const rowData = [serial, itemName, ...fieldValues];
      csvRows.push(rowData.join(','));
    });

    // Create CSV content
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'apo_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  // Export tableData as Excel
//    downloadAsExcel(): void {
//    if (this.tableData.length === 0) {
//       this.notifyService.showWarning('No data available to download', 'Warning');
//       return;
//     }
    
//     // Prepare data for Excel
//     const data: any[] = [];
//    // Get the component name from apoRequest or fallback to a default

//       const componentName = this.componentList.find(
//       comp => Number(comp.id) === Number(this.apoForm.get('component')?.value)
//     )?.name || 'component_report';
//     const sanitizedFileName = this.sanitizeFileName(componentName);
//     if(Number(this.apoForm.get('component')?.value)===1)
//     {
//       this.downoladExcelForm(Number(this.apoForm.get('component')?.value));
//     }else{
// // Add headers
//     const filteredFields = this.dynamicFields.filter(f => f.name !== 'item' && f.name !== 'itemDD');
//     const headers = ['Sl.No.','Items of Works', ...filteredFields.map(field => field.label)];
//     data.push(headers);

//     // Process each row in tableData
//     this.tableData.forEach(row => {
//       const indent = '  '.repeat(row.level); // Indent based on hierarchy level
//       const itemName = `${indent}${this.cleanItemName(row.itemName)}`;
//       const serial = row.serial || '';

//       // Extract dynamic field values
//       const fieldValues = filteredFields.map(field => row.data[field.name] || '');

//       const rowData = [serial, itemName, ...fieldValues];
//       data.push(rowData);
//     });

//     // Create a worksheet
//     const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

//     // Optional: Adjust column widths (approximate)
//     const colWidths = headers.map((header, i) => {
//       const maxLength = Math.max(
//         header.length,
//         ...data.slice(1).map(row => String(row[i] || '').length)
//       );
//       return { wch: Math.min(maxLength + 2, 50) }; // Cap at 50 characters
//     });
//     ws['!cols'] = colWidths;

//     // Create a workbook and add the worksheet
//     const wb: XLSX.WorkBook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'APO Report');

//     // Generate Excel file and trigger download
//     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.setAttribute('href', url);
//     link.setAttribute('download', `${sanitizedFileName}.xlsx`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//     }
//   }
downloadAsExcel(): void {
  if (this.tableData.length === 0) {
    this.notifyService.showWarning('No data available to download', 'Warning');
    return;
  }

  // Prepare data for Excel
  const data: any[] = [];

  // Get the component name from apoRequest or fallback to a default
  const componentName = this.componentList.find(
    comp => Number(comp.id) === Number(this.apoForm.get('component')?.value)
  )?.name || 'component_report';
  const sanitizedFileName = this.sanitizeFileName(componentName);

  if (Number(this.apoForm.get('component')?.value) === 1) {
    this.downoladExcelForm(Number(this.apoForm.get('component')?.value));
  } else {
    // Add headers
    const filteredFields = this.dynamicFields.filter(f => f.name !== 'item' && f.name !== 'itemDD');
    const headers = ['Sl.No.', 'Items of Works', ...filteredFields.map(field => field.label)];
    data.push(headers);

    // Process each row in tableData
    this.tableData.forEach(row => {
      const indent = '  '.repeat(row.level); // Indent based on hierarchy level
      const itemName = `${indent}${this.cleanItemName(row.itemName)}`;
      const serial = row.serial || '';

      // Extract dynamic field values
      const fieldValues = filteredFields.map(field => row.data[field.name] || '');

      const rowData = [serial, itemName, ...fieldValues];
      data.push(rowData);
    });

    // Create a new workbook and worksheet using ExcelJS
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Annual Plan Operation');

    // Add data to the worksheet
    data.forEach((row, rowIndex) => {
      const excelRow = worksheet.addRow(row);
      if (rowIndex === 0) {
        // Style the header row
        excelRow.eachCell(cell => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      }
    });

    // Adjust column widths
    worksheet.columns.forEach((column, i) => {
      const maxLength = Math.max(
        ...(data.map(row => String(row[i] || '').length)),
        headers[i].length
      );
      column.width = Math.min(maxLength + 2, 50);
    });


    // Define all unit columns to apply dropdowns to
    const unitColumns = [
      { name: 'Unit', index: headers.indexOf('Unit') },
      { name: 'Unit (Previous Year)', index: headers.indexOf('Unit (Previous Year)') },
      { name: 'Unit (Current Year prop.)', index: headers.indexOf('Unit (Current Year prop.)') }
    ];
    unitColumns.forEach(unit =>{
      // Find the index of the "Unit" column
    const unitColumnIndex =unit.index ; // Should be 3 (column D, since 0-based index + 1 for Excel column)

    if (unitColumnIndex !== -1) {
      const unitColumnLetter = String.fromCharCode(65 + unitColumnIndex); // Convert to column letter (e.g., 'D')

      // Get the unit options using getUnitOptions
      const unitOptions = this.getUnitOptions();
      // Extract only the labels for the dropdown (excluding the "Select Unit" option)
      const dropdownValues = unitOptions
        .filter(option => option.value !== '') // Exclude the default "Select Unit"
        .map(option => option.label); // e.g., ['Hectare (Ha.)', 'Running KM', 'Numbers (Nos.)']

      // Add data validation (dropdown) to the "Unit" column for rows 2 and below
      for (let rowNum = 2; rowNum <= this.tableData.length + 1; rowNum++) {
        const cell = worksheet.getCell(`${unitColumnLetter}${rowNum}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${dropdownValues.join(',')}"`], // e.g., "Hectare (Ha.),Running KM,Numbers (Nos.)"
          showErrorMessage: true,
          errorStyle: 'error',
          errorTitle: 'Invalid Entry',
          error: 'Please select a unit from the list.',
          showInputMessage: true,
          promptTitle: 'Select Unit',
          prompt: 'Choose the unit from the list (Hectare (Ha.), Running KM, Numbers (Nos.)).'
        };
      }
    }
    });
    

    // Generate the Excel file and trigger download
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${sanitizedFileName}.xlsx`);
    }).catch(err => {
      console.error('Error generating Excel file:', err);
      this.notifyService.showError('Failed to generate Excel file', 'Error');
    });
  }
}

getUnitOptions(): { value: string; label: string }[] {
  if (!unitList || unitList.length === 0) {
    return [{ value: "", label: "Select Unit" }];
  }

  return [
    { value: "", label: "Select Unit" },
    ...unitList.map(option => ({
      value: option.id.toString(),
      label: option.name.trim()
    }))
  ];
}




  // Sanitize the component name to make it a valid file name
  private sanitizeFileName(name: string): string {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_') // Replace non-alphanumeric characters with underscores
      .replace(/_+/g, '_') // Replace multiple underscores with a single one
      .replace(/^_|_$/g, ''); // Remove leading/trailing underscores
  }
downoladExcelForm(componentId:any){
  ////console.log("componentId",componentId);
   
 // Map componentId to the corresponding file name
  let fileName: string;
  switch (Number(componentId)) {
    case 1:
      fileName = 'IDWH-DOLPHIN.xlsx';
      break;
    case 2:
      fileName = 'IDWH-CROCODILE.xlsx';
      break;
    case 3:
      fileName = 'IDWH-BLACKBUCK.xlsx';
      break;
    case 4:
      fileName = 'IDWH_TURTLE.xlsx';
      break;
    case 5:
      fileName = 'IDWH_SANCTUARY_NP.xlsx';
      break;
    case 6:
      fileName = 'APO_CSS_Project_TIGER.xlsx';
      break;
    default:
      this.notifyService.showError('No Excel file available for the selected component.', 'Error');
      return;
  }

  const filePath = `/assets/APO_DOCUMENTS/${fileName}`;
  
  // // Create an anchor element to trigger the download
  // const link = document.createElement('a');
  // link.href = filePath;
  // link.download = fileName; // Set the downloaded file name
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);

  // Check if the file exists before attempting to download
  this.http.head(filePath, { observe: 'response' }).subscribe({
    next: () => {
      // File exists, proceed with download
      const link = document.createElement('a');
      link.href = filePath;
      link.download = fileName; // Set the downloaded file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Show success notification
      this.notifyService.showSuccess(`Excel file "${fileName}" downloaded successfully`, 'Success');
    },
    error: () => {
      // File does not exist
      this.notifyService.showError(`Excel file "${fileName}" not found`, 'Error');
    }
  });
}
openExcelFormModal(): void{
  this.isUploadExcelModalOpen = true;
   // Reset the file input
    const fileInput = document.getElementById('uploadExcelModal') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  this.selectedExcelFile = null; // Reset selected file when opening the modal
}
closeUploadExcelModal(): void {
    this.isUploadExcelModalOpen = false;
    this.selectedExcelFile = null;
    // Reset the file input
    const fileInput = document.getElementById('uploadExcelModal') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
}
onExcelFileChange(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    // Validate file type
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (!validTypes.includes(file.type)) {
      this.notifyService.showError('Please upload a valid Excel file (.xlsx or .xls)', 'Error');
      this.selectedExcelFile = null;
      input.value = ''; // Reset the input
      return;
    }
    this.selectedExcelFile = file;
    this.cdr.markForCheck();
  } else {
    this.selectedExcelFile = null;
  }
}
uploadExcelForm(){
    if (!this.selectedExcelFile) {
    this.notifyService.showError('No file selected', 'Error');
    return;
  }

  const componentId = this.apoForm.get('component')?.value;
  const formData = new FormData();
  formData.append('componentId', componentId);
 // formData.append('userId', this.userid);
  formData.append('file', this.selectedExcelFile);

  this.apiService.request('POST', 'api/v1/APO/parseApoExcel', formData).subscribe({
    next: (response: any) => {
      ////console.log(response);
     if (response.status === 1 && response.data && response.data.length > 0) {

      // Map the response data to update the existing tableData
      ////console.log("tableData before update", this.tableData);

      // Function to update row data if the row is editable
      const updateRowData = (row: TableRow, values: any) => {
        // Only update if the row is editable (has an editableIndex)
        if (typeof row.editableIndex !== 'undefined') {
          row.data = {
            quantity: values.quantity?.toString() || '0',
            unitCost: values.unitCost?.toString() || '0',
            unitDD:   this.getSelectedUnitValue(values.unitDD?.toString()) || '',
            amountRequired: (Number(values.quantity || 0) * Number(values.unitCost || 0)).toString(),
            location: values.location || '',
            gpsDD1: values.gpsdd1?.toString() || '',
            gpsMM1: values.gpsmm1?.toString() || '',
            gpsSS1: values.gpsss1?.toString() || '',
            gpsDD2: values.gpsdd2?.toString() || '',
            gpsMM2: values.gpsmm2?.toString() || '',
            gpsSS2: values.gpsss2?.toString() || '',
            paraDetails		:values.paraDetails?.toString() || '',
            physicalTarget : values.physicalTarget?.toString() || '',
            financialTarget : values.financialTarget?.toString() || '',
            unitKms : values.unitKms?.toString() || '',
            amountINR : values.amountINR?.toString() || '',
            
            paraNoTCP : values.paraNoTCP?.toString() || '',
            paraNoCSS : values.paraNoCSS?.toString() || '',
            physicalTargetPrev : values.physicalTargetPrev?.toString() || '',
            unitPrev : this.getSelectedUnitValue(values.unitPrev?.toString()) || '',
            physicalAchievementPrev: values.physicalAchievementPrev?.toString() || '',
            financialTargetPrev: values.financialTargetPrev?.toString() || '',
            financialAchievementPrev: values.financialAchievementPrev?.toString() || '',
            physicalTargetCurr: values.physicalTargetCurr?.toString() || '',
            unitCurr: this.getSelectedUnitValue(values.unitCurr?.toString()) || '',
            unitCostCurr: values.unitCostCurr?.toString() || '',
            financialTargetCurr: values.financialTargetCurr?.toString() || '',
      
            //itemDD: row.data?.itemDD || '' // Preserve existing itemDD if present
          };
          row.isSaved=false;
          row.errors = {};
          this.dynamicFields.forEach(field => {
            row.errors[field.name] = '';
            
          });
        }
      };

      // Recursive function to process tasks and subtasks
      const processTasks = (tasks: any[], parentTaskId: number = 0) => {
        tasks.forEach((item: any, index: number) => {
          const mapId = item.mapId || 0;
          const typeId = item.typeId || null;
          const taskId = item.taskId || Date.now() + index;
          const values = item.apoValueResponse || {};

          // Update matching row in tableData
          this.tableData.forEach(row => {
            if (row.mapId === mapId && row.taskId === taskId) {
              updateRowData(row, values);
            }
          });

          // Process subtasks recursively
          if (item.subTaskList && item.subTaskList.length > 0) {
            processTasks(item.subTaskList, taskId);
          }
        });
      };

      // Start processing the taskList
      if (response.data[0].taskList && Array.isArray(response.data[0].taskList)) {
        processTasks(response.data[0].taskList);
      }

        this.notifyService.showSuccess('Excel file uploaded and data populated successfully', 'Success');
      } else {
        this.notifyService.showError('No valid data found in the Excel file', 'Error');
      }
    },
    error: (error) => {
      console.error('Error uploading Excel file:', error);
      this.notifyService.showError('Error uploading Excel file', 'Error');
    },
    complete: () => {
      this.selectedExcelFile = null;
      this.isUploadExcelModalOpen = false;
      const fileInput = document.getElementById('uploadExcel') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
      this.cdr.markForCheck();
    }
  });
}
getSelectedUnitValue(unitName:string){
  let unit;
  if(unitName!=undefined){
       unit= unitList.find((item: any) => item.name.toLowerCase() === unitName.toLowerCase());
  }
  return unit ? unit.id : undefined;
}

//************************************************************************************* */
private loadReportFormDetails(componentId: string) {
    this.isLoading = true;
    this.isFormReady = false;
    //this.processHierarchicalData(apoObject.taskList);
    this.apiService.request('GET', `api/v1/APO/getAllReportFormDetails?componentId=${componentId}`).subscribe(
      (data: any) => {
       //console.log(data)
        this.isLoading = false;
        if (data && Array.isArray(data) && data.length > 0) {
          this.originalData = data[0];
          this.formTitle = data?.[0]?.reportName;
          this.formDesc = data?.[0]?.about;

          if (data[0].taskList && Array.isArray(data[0].taskList)) {
              const mapIdLists=[];
              const processTasks = (tasks: APOTask[], level: number = 0) => {
                tasks.forEach(task => {
                  

                  if(task.ddavailable){
                     mapIdLists.push(task.mapId);
                  }
                if (task.subTaskList && task.subTaskList.length > 0) {
                    processTasks(task.subTaskList, level + 1);
                }
                    
                });
              };
              processTasks(data[0].taskList);
              ////console.log("mapIdLists",mapIdLists);
              this.getDDListform(mapIdLists);
              if(mapIdLists.length>0){
                // Fetch dropdown data first
                  this.getDDListform(mapIdLists).subscribe({
                    next: () => {
                      // Process hierarchical data only after dropdown data is fetched
                     setTimeout(() => { // 🚀 Smoother UI updates
              this.processHierarchicalData(data[0].taskList);
              //this.cdr.markForCheck(); // 🚀 Manually trigger change detection
            }, 10);
                      this.isLoading = false;
                      //this.cdr.markForCheck();
                    },
                    error: (err) => {
                      this.notifyService.showError('Failed to load dropdown data', 'Error');
                       setTimeout(() => { // 🚀 Smoother UI updates
              this.processHierarchicalData(data[0].taskList);
              //this.cdr.markForCheck(); // 🚀 Manually trigger change detection
            }, 10);
                      this.isLoading = false;
                      //this.cdr.markForCheck();
                    }
                  });
              }else{
                 setTimeout(() => { // 🚀 Smoother UI updates
              this.processHierarchicalData(data[0].taskList);
              this.cdr.markForCheck(); // 🚀 Manually trigger change detection
            }, 10);
              }

           
          } else {

            this.notifyService.showWarning('No items found in report details', 'Warning');
            this.isInitialized = false;
            this.isFormReady = false;
          }
        } else {

          this.notifyService.showWarning('No report details found', 'Warning');
          this.isInitialized = false;
          this.isFormReady = false;
        } 
      },
      (error) => {
        this.isLoading = false;
       
        this.notifyService.showError('Failed to load report details', 'Error');
        this.isInitialized = false;
            this.isFormReady = false;
        this.cdr.markForCheck();
      }
    );
}
getDDListform(mapIdLists: any[]) {
    return this.apiService.request('POST', `api/v1/APO/getAllDDValue`, mapIdLists).pipe(
      tap({
        next: (data: any) => {
          ////console.log('Dropdown data received: ', data);
          this.ddListsform = data || [];
        },
        error: (err) => {
          console.error('Error fetching dropdown data:', err);
          this.notifyService.showError('Failed to load dropdown data', 'Error');
          this.ddListsform = [];
        }
      })
    );
}
getDDTypeList(mapIdLists:any){
  const intList = mapIdLists.map(id => parseInt(id, 10));
    this.apiService.request('POST', `api/v1/APO/getAllDDValue`, intList).subscribe({
      next:(value:any[])=> {
           if(value){
            this.typeListform = value || [];
           }else{
            this.typeListform=[];
            this.siteSpecificationFilterForm.patchValue({
               typeId: ''
             });
           }
      },error:(err) =>{
          console.error('Error fetching dropdown data:', err);
          this.typeListform=[];
            this.siteSpecificationFilterForm.patchValue({
               typeId: ''
           });
      },
    });
    this.cdr.markForCheck();
}
getAllDocumentType(){
    return this.apiService.request('GET', `api/v1/APO/getAllDocumentType`).subscribe({
      next: (data: any) =>{
        ////console.log('Document type data received: ', data);
        this.documentTypeLists=data || [];
      },
      error: (error:any)=>{
        console.error('Error fetching document type data:', error);
      }
    })
  }
private processHierarchicalData(tasks: APOTask[]): void {  
    ////console.log("processHierarchicalData :",tasks);
    if (!this.dynamicFields.length) {
      this.isFormReady = false;
      //this.cdr.markForCheck();
      return;
    }
    this.tableData = [];
    let editableIndex = -1;
    editableIndex = this.processTasks(tasks, 1, editableIndex);
    if(this.tableData.length>0){
      //First, map the tableData to the desired format
      const mappedList = this.tableData.map(item => ({
        mapId: item.mapId,
        itemName: item.itemName
      }));

      // Then, filter to keep only unique entries based on apoId and itemName
      this.apoIdItemNameList = mappedList.filter((item, index, self) =>
        index === self.findIndex(t => t.mapId === item.mapId && t.itemName === item.itemName)
      );
      // this.apoIdItemNameList = Array.from(
      //     new Map(
      //       this.tableData.map(item => [`${item.apoId}_${item.itemName}`, {
      //         apoId: item.apoId,
      //         itemName: item.itemName
      //       }])
      //     ).values()
      //   );
        ////console.log(this.apoIdItemNameList);
    }
    // Store a deep copy of tableData as the initial state
    this.initialTableData = JSON.parse(JSON.stringify(this.tableData));
    this.isInitialized = true;
    this.isFormReady = this.isReadOnly ? this.tableData.length > 0 : this.tableData.some(row => row.editableIndex !== undefined);
   // this.isFormReady = this.tableData.some(row => row.editableIndex !== undefined);
    this.cdr.markForCheck();
  }
private processTasks(tasks: APOTask[], level: number,  editableIndex: number, parentTaskId: number = 0): number {
 ////console.log(tasks);
    const serialFormats = [
      (index: number) => (index + 1).toString(),
      (index: number) => `(${this.toRoman(index + 1)})`,
      (index: number) => `(${String.fromCharCode(97 + index)})`,
      (index: number) => `(${index + 1})`
    ];
    const formatIndex = Math.min(level - 1, serialFormats.length - 1);
    const serialFormatter = serialFormats[formatIndex] || serialFormats[serialFormats.length - 1];

    // Sort tasks by taskId
    const sortedTasks = [...tasks].sort((a, b) => a.orderId - b.orderId);

    ////console.log(sortedTasks);
    sortedTasks.forEach((task, index) => {
      const hasChildren = !!task.subTaskList?.length;
      const serial = serialFormatter(index);

     if (this.isViewMode) {
      // Handle tasks with apoTypeWiseValues
      if (task.apoTypeWiseValues && task.apoTypeWiseValues.length > 0) {
        task.apoTypeWiseValues.forEach((type: any, typeIndex: number) => {
          type.apoValueResponses.forEach((response: any, responseIndex: number) => {
            const syntheticTaskId = Number(`${task.taskId}${type.typeId}${responseIndex}`);
          //  //console.log(syntheticTaskId);
            //const itemName = `${task.taskName} - ${type.typeName}`;
            const itemName = `${task.taskName}`;
            const row = this.createDataRow({
              serial: hasChildren ? serial : `${serial}.${typeIndex + 1}`,
              name: itemName,
              level,
              hasChildren: false,
              taskId: syntheticTaskId,
              parentId: task.parentId || parentTaskId,
              mapId: task.mapId,
              apoId: type.apoId,
              typeId: type.typeId,
              typeName: type.typeName,
            });
            row.syntheticTaskId = syntheticTaskId;
           
            this.initializeRowData(row, task, type.typeName);
             this.tableData.push(row);
            if (!this.isReadOnly) {
              row.editableIndex = ++editableIndex;
            }
              // Assign dropdown options for this row
            // this.assignDropdownOptionsForRow(row);
          });
        });
      } else{
        // If no apoTypeWiseValues, or we still need the parent row if it has children
        // Tasks without apoTypeWiseValues (if any)
        if ( hasChildren) {
          const row = this.createDataRow({
            serial,
            name: task.taskName,
            level,
            hasChildren,
            taskId: task.taskId,
            parentId: task.parentId || parentTaskId,
            mapId: task.mapId,
            typeId:task.typeId,
            apoId: task.apoId,

          });
          this.tableData.push(row);
          this.initializeRowData(row,task);
          if (!hasChildren && !this.isReadOnly) {
            row.editableIndex = ++editableIndex;
          }
          // Assign dropdown options for this row
          //this.assignDropdownOptionsForRow(row);
        }else{
          const row = this.createDataRow({
            serial,
            name: task.taskName,
            level,
            hasChildren,
            taskId: task.taskId,
            parentId: task.parentId || parentTaskId,
            mapId: task.mapId,
            typeId:task.typeId,
            apoId: task.apoId,
          });
          this.tableData.push(row);
          this.initializeRowData(row,task);
        }
      }
    }else {
      // Entry Mode: Use ddListsform to pre-populate rows
         if (task.apoTypeWiseValues && task.apoTypeWiseValues.length > 0) {
        task.apoTypeWiseValues.forEach((type: any, typeIndex: number) => {
          type.apoValueResponses.forEach((response: any, responseIndex: number) => {
            const syntheticTaskId = Number(`${task.taskId}${type.typeId}${responseIndex}`);
            //const itemName = `${task.taskName} - ${type.typeName}`;
            const itemName = `${task.taskName}`;
            const row = this.createDataRow({
              serial: hasChildren ? serial : `${serial}.${typeIndex + 1}`,
              name: itemName,
              level,
              hasChildren: false,
              taskId: syntheticTaskId,
              parentId: task.parentId || parentTaskId,
              mapId: task.mapId,
              apoId: type.apoId,
              typeId: type.typeId,
              typeName: type.typeName,
              islandBased:task.landBase
            });
            row.syntheticTaskId = syntheticTaskId;
           
            this.initializeRowData(row, task, type.typeName);
             this.tableData.push(row);
            if (!this.isReadOnly) {
              row.editableIndex = ++editableIndex;
            }
              // Assign dropdown options for this row
             this.assignDropdownOptionsForRow(row);
          });
        });
       }
        else if (task.ddavailable && task.mapId) {
          const relevantOptions = this.ddListsform.filter(dd => dd.mapId === task.mapId);
          relevantOptions.forEach((option, optIndex) => {
            const row = this.createDataRow({
              serial: hasChildren ? `${serial}.${optIndex + 1}` : serial,
              name: task.taskName,
              level,
              hasChildren: false,
              taskId: Date.now() + optIndex,
              parentId: task.parentId || parentTaskId,
              mapId: task.mapId,
              apoId: task.apoId || 0,
              typeId: option.typeId,
              typeName: option.ddValue,
               islandBased:task.landBase
            });

            this.tableData.push(row);
            this.initializeRowData(row, task, option.ddValue);

            if (!this.isReadOnly) {
              row.editableIndex = ++editableIndex;
            }

            this.assignDropdownOptionsForRow(row);
          });
        } else {
          const row = this.createDataRow({
            serial,
            name: task.taskName,
            level,
            hasChildren,
            taskId: task.taskId,
            parentId: task.parentId || parentTaskId,
            mapId: task.mapId || 0,
            typeId:task.typeId || null,
            apoId: task.apoId || 0,
            islandBased:task.landBase
          });

          this.tableData.push(row);
          this.initializeRowData(row, task);

          if (!hasChildren && !this.isReadOnly) {
            row.editableIndex = ++editableIndex;
          }

          this.assignDropdownOptionsForRow(row);
        }
    }
      // const row = this.createDataRow({
      //   serial,
      //   name: task.taskName,
      //   level,
      //   hasChildren,
      //   taskId: task.taskId,
      //   parentId: task.parentId || parentTaskId,
      //   mapId:task.mapId,
      //   apoId:task.apoId
      // });
      // this.tableData.push(row);

      // if (!hasChildren && !this.isReadOnly) {
      //   row.editableIndex = ++editableIndex;
      //   this.initializeRowData(row);
      // }
      // if (!hasChildren) {
      //       this.initializeRowData(row);
      //       if (!this.isReadOnly) {
      //       row.editableIndex = ++editableIndex;
      //     }
      //  }
      if (task.subTaskList?.length) {
        editableIndex = this.processTasks(task.subTaskList, level + 1, editableIndex, task.taskId);
      }
    });
    return editableIndex;
}

//  addNewRow(currentRow: TableRow): void {
//   if (!this.isFormReady) {
//     this.notifyService.showWarning('Form is not ready. Please ensure all prerequisites are met.', 'Warning');
//     return;
//   }

//   if (this.tableData.length >= this.maxRows) {
//     this.notifyService.showWarning(`Cannot add more than ${this.maxRows} rows`, 'Warning');
//     return;
//   }

//   // Check if the dropdown has only one option
//   const availableOptions = currentRow.dropdownOptions || [];
//   if (availableOptions.length <= 1) {
//     this.notifyService.showWarning('Cannot add a new row: No more dropdown options available', 'Warning');
//     return;
//   }

//   const lastEditableRow = this.tableData
//     .filter(row => row.editableIndex !== undefined)
//     .slice(-1)[0] || null;

//   const level = currentRow.level || 1;
//   const serial = lastEditableRow
//     ? `${parseInt(lastEditableRow.serial, 10) + 1}`
//     : '1';

//   const newRow: TableRow = this.createDataRow({
//     serial,
//     name: currentRow.itemName || '', // Copy itemName from currentRow
//     level,
//     hasChildren: false,
//     taskId: Date.now(),
//     parentId: currentRow.parentId || 0,
//     mapId: currentRow.mapId || 0, // Same mapId as currentRow
//     apoId: currentRow.apoId || 0
//   });

  
//   // Copy all data fields from the current row as default values
//   this.dynamicFields.forEach(field => {
//     if (field.name === 'itemDD') {
//       newRow.data[field.name] = ''; // Will be set by assignDropdownOptionsForRow
//     } else {
//       newRow.data[field.name] = currentRow.data[field.name] || (field.type === 'text' ? '' : field.type === 'number' ? 0 : '');
//     }
//     newRow.errors[field.name] = '';
//   });

//   // Assign dropdown options, passing currentRow to exclude its selected option
//   this.assignDropdownOptionsForRow(newRow);

//   const lastEditableIndex = Math.max(
//     ...this.tableData.map(row => row.editableIndex || 0),
//     0
//   );
//   newRow.editableIndex = lastEditableIndex + 1;

//   const currentRowIndex = this.tableData.indexOf(currentRow);
//   this.tableData.splice(currentRowIndex + 1, 0, newRow);

//   this.apoIdItemNameList = this.tableData.map(item => ({
//     apoId: item.apoId,
//     itemName: item.itemName
//   }));

//   this.isFormReady = true;
//   this.checkAllRowsSaved();
//   //this.cdr.markForCheck();

//   this.notifyService.showSuccess('New row added successfully', 'Success');
// }
// Add a method to remove a row
// removeRow(row: TableRow): void {
//   if (this.tableData.length <= 1) {
//     this.notifyService.showWarning('Cannot remove the last row', 'Warning');
//     return;
//   }

//   const rowIndex = this.tableData.indexOf(row);
//   if (rowIndex !== -1) {
//     this.tableData.splice(rowIndex, 1);
//     // Reassign dropdown options for remaining rows to update available options
//     this.tableData.forEach(r => {
//       if (r.mapId === row.mapId) {
//         this.assignDropdownOptionsForRow(r);
//       }
//     });
//     this.apoIdItemNameList = this.tableData.map(item => ({
//       apoId: item.apoId,
//       itemName: item.itemName
//     }));
//     this.checkAllRowsSaved();
//     this.notifyService.showSuccess('Row removed successfully', 'Success');
//     this.cdr.markForCheck();
//   }
// }
// Add this method to get all selected typeIds across rows
private getSelectedTypeIds(excludeRow?: TableRow): number[] {
  return this.tableData
    .filter(row => row !== excludeRow && row.data['itemDD'] && row.data['itemDD'] !== '')
    .map(row => Number(row.data['itemDD']));
}
private assignDropdownOptionsForRow(row: TableRow, currentRow?: TableRow): void {
  if (row.mapId && this.ddListsform) {
    // Filter dropdown options based on the row's mapId
    const allOptions:any = this.ddListsform.filter(dd => dd.mapId === row.mapId);
    if (allOptions.length > 0) {
      row.dropdownOptions = allOptions.map(option => ({
        value: option.typeId,
        label: option.ddValue
      }));
      // Pre-select the dropdown with the row's typeId
      row.data['itemDD'] = row.typeId?.toString() || '';
    } else {
      row.dropdownOptions = [];
      row.data['itemDD'] = '';
    }
  } else {
    row.dropdownOptions = [];
    row.data['itemDD'] = '';
  }
 if (this.unitList.length > 0) {
  row.unitDropdownOptions = [
    { value: "", label: "Select Unit" },
    ...this.unitList.map(option => ({
      value: option.id.toString(),
      label: option.name
    }))
  ];
  // if (!row.data['unitDD'] && row.unit) {
  //   const matchingUnit = this.unitList.find(unit => unit.name === row.unit);
  //   row.data['unitDD'] = matchingUnit ? matchingUnit.id.toString() : '';
  // }
}
  this.cdr.markForCheck();
  }
  // getDropdownOptions(field: FieldDefinition, row: TableRow): { value: number; label: string }[] {
  //  // return field.options || [];
  //    if (field.name !== 'itemDD' || !row || !row.dropdownOptions) {
  //     return [];
  //   }
  //  const options = row.dropdownOptions.map(option => ({
  //     value: option.typeId,
  //     label: option.ddValue
  //   })) || [];
  //   ////console.log(`Dropdown options for row ${row.serial}:`, options);
  //    ////console.log(`Current row.data['itemDD'] value:`, row.data['itemDD']);
  //   return options;
  // }
// Handle dropdown change
  // onDropdownChange(value: any, row: TableRow, fieldName: string): void {
  //  row.data[fieldName] = value ? Number(value) : '';
  //   this.validateField(row, fieldName);
  //   this.cdr.markForCheck();
  // }
  onDropdownChange(value: any, row: TableRow, fieldName: string): void {
  row.data[fieldName] = value; // Ensure the value is updated
  this.cdr.markForCheck(); // Trigger change detection
}
  onRowClick(row: TableRow): void {
   // //console.log(`Row clicked: ${row.serial}, itemDD: ${row.data['unitDD']}`);
    this.currentRow = row;
    // Only reassign options if necessary (e.g., if dropdownOptions are not set)
  //  if(! this.isViewMode){
  //     if (!row.dropdownOptions || row.dropdownOptions.length === 0) {
  //         this.assignDropdownOptionsForRow(row);
  //       }
  //  }
  this.cdr.markForCheck();
    //this.cdr.markForCheck();
  }

  //**************************************************************************************************************** */


  private createDataRow(config: 
    { serial: string;
      name: string;
      level: number;
      hasChildren?: boolean;
      taskId?: number;
      parentId?: number;
      mapId: number;
      apoId:number;
      typeId:number;
      typeName?: string,
      islandBased?: boolean;
    }): TableRow {
    return {
      serial: config.serial,
      itemName: config.name,
      level: config.level as any,
      hasChildren: config.hasChildren || false,
      isSaved: this.isReadOnly,
      additionalInfo: {},
      siteSpecification:{},
      siteSpecifictaionCount:0, 
      data: {},
      errors: {},
      taskId: config.taskId,
      parentId: config.parentId,
      mapId:config.mapId,
      typeId:config.typeId || null,
      apoId:config.apoId,
      typeName: config.typeName,
      islandBased:config.islandBased || false,
      isGeometryUploaded:false
    };
  }
  private initializeRowData(row: TableRow, task: APOTask, typeName?: string) {
    const taskId = row.syntheticTaskId || Number(row.mapId);
    const apoJsonValues = this.apoJsonValuesMap.get(taskId);
    ////console.log(apoJsonValues);

    this.dynamicFields.forEach(field => {
      //if (field.editable) {
        let value = '';
      if (!row.hasChildren) {
        if (this.isViewMode) {
        //  //console.log("in")
           if (field.name === 'itemDD' && typeName) {
              value = typeName.trim();
            }
//             else if ((field.name === 'unitDD') 
//                       || (field.name === 'unitPrev') 
//                       || (field.name === 'unitCurr')  ) {
//  //console.log("in 333")
//   //console.log( row)

  

//               const id=row.data['unitDD'] ||  row.data['unitPrev'] ||  row.data['unitCurr'];
//               //console.log(id)
//              const unit = this.unitList.find(x => x.id == id);
//   //             let unit;
//   // if(unitName!=undefined){
//   //      unit= unitList.find((item: any) => item.name.toLowerCase() === unitName.toLowerCase());
//   // }
//   // return unit ? unit.id : undefined;
//              value = unit ? unit.name : undefined;
//             }
            else if (apoJsonValues) {
               const apoKeys = Object.keys(apoJsonValues);
               const matchingKey = apoKeys.find(k => k.toLowerCase() === field.name.toLowerCase());
                if (matchingKey && apoJsonValues[matchingKey] !== null && apoJsonValues[matchingKey] !== undefined) {
                  value = apoJsonValues[matchingKey]!.toString();
                }
            }
          // if (apoJsonValues) {
          //   const apoKeys = Object.keys(apoJsonValues);
          //   const matchingKey = apoKeys.find(k => k.toLowerCase() === field.name.toLowerCase());
          //   if (matchingKey && apoJsonValues[matchingKey] !== null && apoJsonValues[matchingKey] !== undefined) {
          //     value = apoJsonValues[matchingKey]!.toString();
          //   }
          // }else if (field.name === 'itemDD' && typeName) {
          //    //console.log("typeName",typeName);
          //    // Explicitly set itemDD to typeName for apoTypeWiseValues rows
          //    value = typeName.trim();
          // } 
        } else {
          if (field.name === 'quantity' && task.defaultValue !== null) {
            value = task.defaultValue.toString();
          } else if (field.name === 'unitCost' && task.defaultUnitValue !== null) {
            value = task.defaultUnitValue.toString();
          }
          else  if (field.name === 'itemDD' && row.typeId) {
               value = row.typeId.toString();
          }
        }
      }
        row.data[field.name] = value;
        row.errors[field.name] = '';
      //}
    });
     if (!row.hasChildren) {
      // Calculate amountRequired as quantity * unitCost
      const quantity = Number(row.data['quantity']) || 0;
      const unitCost = Number(row.data['unitCost']) || 0;
       // const value=quantity * unitCost;
      row.data['amountRequired'] = (quantity * unitCost).toString();

     }
  // //console.log(`  Resulting row.data=`, row.data);
  }
  // Method to update amountRequired when quantity or unitCost changes
  updateAmountRequired(row: TableRow): void {
    ////console.log("row",row)
    const quantity = Number(row.data['quantity']) || 0;
    const unitCost = Number(row.data['unitCost']) || 0;
    const value=quantity * unitCost;
   // //console.log("value",value)
    row.data['amountRequired'] = (quantity * unitCost).toString();
    //this.cdr.markForCheck();
  }
  validateQuantity(row :TableRow):boolean{
    let hasErrors=false;
    // Validate quantity format***********************************************
  const quantityRaw = row.data['quantity'] || '';
  const quantity = Number(quantityRaw);
  if (quantityRaw !== '' && isNaN(quantity)) {
    row.errors['quantity'] = 'Quantity must be a valid number';
    hasErrors=true;
  }

  const physicalTargetRaw = row.data['physicalTarget'] || '';
  const physicalTarget = Number(physicalTargetRaw);
  if (physicalTargetRaw !== '' && isNaN(physicalTarget)) {
    row.errors['physicalTarget'] = 'physicalTarget must be a valid number';
    hasErrors=true;
  }

  // Validate quantity and unitDD
  const unit = row.data['unitDD'] || '';
  if (!isNaN(quantity) && quantity > 0 && unit === '') {
    row.errors['unitDD'] = 'Unit is required when quantity is greater than 0';
   hasErrors=true;
  }

  if (!isNaN(physicalTarget) && physicalTarget > 0 && unit === '') {
    row.errors['unitDD'] = 'Unit is required when physicalTarget is greater than 0';
   hasErrors=true;
  }

   // Validate quantity and unitDD
  const unitCost = row.data['unitCost'] || '';
  if (!isNaN(quantity) && quantity > 0 && unitCost === '') {
    row.errors['unitCost'] = 'Unit Cost is required when quantity is greater than 0';
   hasErrors=true;
  }
 
  //  if(!isNaN(quantity) &&  unit === '3' && quantity > row.siteSpecifictaionCount   && row.islandBased==true ) {
  //     this.isErrorInSitesSubmitted=true;
  //       //console.log("unitCost unit 3  isErrorInSitesSubmitted",this.isErrorInSitesSubmitted)
  //  }
   //prev_target
  // prev_unitDD
  const physicalTargetPrev = row.data['physicalTargetPrev'] || '';
  const Prequantity = Number(physicalTargetPrev);
  if (physicalTargetPrev !== '' && isNaN(Prequantity)) {
    row.errors['physicalTargetPrev'] = 'Physical Target must be a valid number';
   hasErrors=true;
  }
   
  const unitPrev = row.data['unitPrev'] || '';
  if (!isNaN(Prequantity) && Prequantity > 0 && unitPrev === '') {
    row.errors['unitPrev'] = 'Unit is required when Previous Target is greater than 0';
   hasErrors=true;
  }
  
  // if(!isNaN(Prequantity)  && Prequantity > row.siteSpecifictaionCount   && row.islandBased==true ) {
  //     this.isErrorInSitesSubmitted=true;
  //     //console.log("pre_unitCost  isErrorInSitesSubmitted",this.isErrorInSitesSubmitted)
  // } 
  // else if(!isNaN(Prequantity) &&  unitPrev === '3' && Prequantity > row.siteSpecifictaionCount   && row.islandBased==true ) {
  //     this.isErrorInSitesSubmitted=true;
  //     //console.log("pre_unitCost unit3 isErrorInSitesSubmitted",this.isErrorInSitesSubmitted)
  // } 
  //Current
  const physicalTargetCurr = row.data['physicalTargetCurr'] || '';
  const currentquantity = Number(physicalTargetCurr);
  if (physicalTargetCurr !== '' && isNaN(currentquantity)) {
    row.errors['physicalTargetCurr'] = 'Physical Target must be a valid number';
   hasErrors=true;
  }
    
  const unitCurr = row.data['unitCurr'] || '';
  if (!isNaN(currentquantity) && currentquantity > 0 && unitCurr === '') {
    row.errors['unitCurr'] = 'Unit is required when Physical Target is greater than 0';
   hasErrors=true;
  }
 const currentunitCost = row.data['unitCostCurr'] || '';
  if (!isNaN(currentquantity) && currentquantity > 0 && currentunitCost === '') {
    row.errors['unitCostCurr'] = 'Unit Cost is required when Physical Target is greater than 0';
   hasErrors=true;
  }

  //  if(!isNaN(currentquantity)  && currentquantity > row.siteSpecifictaionCount   && row.islandBased==true ) {
  //     this.isErrorInSitesSubmitted=true;
  //     //console.log("unitCostCurr isErrorInSitesSubmitted",this.isErrorInSitesSubmitted)
  //  }
  //  else if(!isNaN(currentquantity) &&  unitCurr === '3' && currentquantity > row.siteSpecifictaionCount  && row.islandBased==true ) {
  //     this.isErrorInSitesSubmitted=true;
  //     //console.log("unitCostCurr unit3 isErrorInSitesSubmitted",this.isErrorInSitesSubmitted)
  //  }
   return hasErrors;
   //********************************* */
  }
 validateField(row: TableRow, fieldName: string): boolean {
  const value = row.data[fieldName] || '';
  row.errors[fieldName] = '';
  const field = this.dynamicFields.find(f => f.name === fieldName);
  if (!field) {
    row.errors[fieldName] = 'Field not defined';
    return false;
  }

  // If the value is empty, null, or undefined, clear the error (fields are optional)
  if (value === null || value === '' || value === undefined) {
    row.errors[fieldName] = '';
    row.data[fieldName] = '';
    // Continue with GPS dependency check
  }


  // Location validation (location, prev_location_division, curr_location_division)
  const locationFields = ['location', 'prev_location_division', 'curr_location_division'];
  if (locationFields.includes(fieldName) && value !== '') {
    const locationValue = String(value);
    const locationRegex = /^[a-zA-Z0-9\s,.-]+$/;
    if (locationValue.length < 3) {
      row.errors[fieldName] = `${field.label} must be at least 3 characters long`;
    }
    if (!locationRegex.test(locationValue)) {
      row.errors[fieldName] = `${field.label} can only contain letters, numbers, spaces, commas, periods, and hyphens`;
    }
  }

  // GPS coordinate validation: If any GPS field has a value, all are required
  // const gpsFields = ['gpsDD1', 'gpsMM1', 'gpsSS1', 'gpsDD2', 'gpsMM2', 'gpsSS2'];
  // if (gpsFields.includes(fieldName)) {
  //   const gpsDD1 = row.data['gpsDD1'] || '';
  //   const gpsMM1 = row.data['gpsMM1'] || '';
  //   const gpsSS1 = row.data['gpsSS1'] || '';
  //   const gpsDD2 = row.data['gpsDD2'] || '';
  //   const gpsMM2 = row.data['gpsMM2'] || '';
  //   const gpsSS2 = row.data['gpsSS2'] || '';

  //   // Check if any GPS field has a value
  //   const anyGpsFieldFilled = gpsDD1 || gpsMM1 || gpsSS1 || gpsDD2 || gpsMM2 || gpsSS2;

  //   // If any GPS field has a value, all GPS fields are required
  //   if (anyGpsFieldFilled) {
  //     if (!gpsDD1) {
  //       row.errors['gpsDD1'] = 'Latitude DD is required when any GPS coordinate is provided';
  //     }
  //     if (!gpsMM1) {
  //       row.errors['gpsMM1'] = 'Latitude MM is required when any GPS coordinate is provided';
  //     }
  //     if (!gpsSS1) {
  //       row.errors['gpsSS1'] = 'Latitude SS is required when any GPS coordinate is provided';
  //     }
  //     if (!gpsDD2) {
  //       row.errors['gpsDD2'] = 'Longitude DD is required when any GPS coordinate is provided';
  //     }
  //     if (!gpsMM2) {
  //       row.errors['gpsMM2'] = 'Longitude MM is required when any GPS coordinate is provided';
  //     }
  //     if (!gpsSS2) {
  //       row.errors['gpsSS2'] = 'Longitude SS is required when any GPS coordinate is provided';
  //     }
  //   } else {
  //     // If no GPS fields have values, clear errors for all GPS fields
  //     gpsFields.forEach(gpsField => {
  //       row.errors[gpsField] = '';
  //     });
  //   }
  // }

  // GPS Degrees validation for Latitude (gpsDD1, prev_dd, curr_dd)
  const degreeFields1 = ['gpsDD1', 'prev_dd', 'curr_dd'];
  if (degreeFields1.includes(fieldName) && value !== '') {
    const num = Number(value);
    if (isNaN(num)) {
      row.errors[fieldName] = 'Latitude Degrees must be a valid number';
    } else if (!Number.isInteger(num) || num < 17.780 || num > 22.730) {
      row.errors[fieldName] = 'Latitude Degrees must be an integer between 17.780 and 22.730';
    }
  }

  // GPS Degrees validation for Longitude (gpsDD2, prev_dd2, curr_dd2)
  const degreeFields2 = ['gpsDD2', 'prev_dd2', 'curr_dd2'];
  if (degreeFields2.includes(fieldName) && value !== '') {
    const num = Number(value);
    if (isNaN(num)) {
      row.errors[fieldName] = 'Longitude Degrees must be a valid number';
    } else if (!Number.isInteger(num) || num < 81.37 || num > 87.53) {
      row.errors[fieldName] = 'Longitude Degrees must be an integer between 81.37 and 87.53';
    }
  }

  // GPS Minutes validation
  const minuteFields = ['gpsMM1', 'gpsMM2', 'prev_mm', 'prev_mm2', 'curr_mm', 'curr_mm2'];
  if (minuteFields.includes(fieldName) && value !== '') {
    const num = Number(value);
    if (isNaN(num)) {
      row.errors[fieldName] = 'Minutes must be a valid number';
    } else if (!Number.isInteger(num) || num < 0 || num >= 60) {
      row.errors[fieldName] = 'Minutes must be an integer between 1 and 59';
    }
  }

  // GPS Seconds validation
  const secondFields = ['gpsSS1', 'gpsSS2', 'prev_ss', 'prev_ss2', 'curr_ss', 'curr_ss2'];
  if (secondFields.includes(fieldName) && value !== '') {
    const num = Number(value);
    if (isNaN(num)) {
      row.errors[fieldName] = 'Seconds must be a valid number';
    } else if (num < 0 || num >= 60) {
      row.errors[fieldName] = 'Seconds must be between 1 and 59';
    }
  }

  // General number validation for other number fields
  if (field.type === 'number' && !locationFields.concat(degreeFields1, degreeFields2, minuteFields, secondFields).includes(fieldName) && value !== '') {
    const num = Number(value);
    if (isNaN(num)) {
      row.errors[fieldName] = `${field.label} must be a valid number`;
    } else if (num < 0) {
      row.errors[fieldName] = `${field.label} must be a non-negative number`;
    }
  }

  // Return true if no errors for this field, false otherwise
  return row.errors[fieldName] === '';
}


  getEditableFieldsCount(): number {
    if (!this.dynamicFields) return 0;
    return this.dynamicFields.filter(f => f.editable).length;
  }

  //**********Site Specification ************************************************ */
  openSiteSpecificationModal(row: TableRow){
    if (row.editableIndex === undefined) {
          return;
        }
    this.selectedRow = row;
    this.isModalSiteSpecificationOpen = true;
    this.siteImages = [];
    this.supportiveDocumentPreviewUrl = null;
        this.supportiveDocumentBlobUrl=null;
    this.supportiveDocumentFile=null;
    //this.wordCount = 0;
    this.charCount = 0;
    this.siteSpecificationForm.reset();
    this.cdr.detectChanges();
  }
closeSiteSpecificationModal(){
    this.isModalSiteSpecificationOpen = false;
    this.siteImages.forEach(image => {
      if (image.previewUrl) {
        URL.revokeObjectURL(image.previewUrl);
      }
    });
    this.selectedRow = null;
    this.siteImages = [];
    this.tempSiteImage = null;
    this.tempSiteImagePreview = null;
    this.tempSiteImageCoordinates = null;
    this.supportiveDocumentPreviewUrl = null;
    this.supportiveDocumentBlobUrl=null;
    this.supportiveDocumentFile=null;
    this.charCount = 0;
    this.siteSpecificationForm.reset();
    this.cdr.detectChanges();
}
  updateWordCount(): void {
    const remarks = this.siteSpecificationForm.get('remarks')?.value || '';
    const words = remarks.trim().split(/\s+/).filter((word: string) => word.length > 0);
    this.wordCount = words.length;
    if (this.wordCount > 300) {
      this.siteSpecificationForm.get('remarks')?.setErrors({ wordLimitExceeded: true });
    } else if (remarks.trim().length === 0) {
      this.siteSpecificationForm.get('remarks')?.setErrors({ required: true });
    } else {
      this.siteSpecificationForm.get('remarks')?.setErrors(null);
    }
    this.cdr.detectChanges();
  }
  updateCharCount(): void { 
    const remarksControl = this.modalForm.get('remarks');
    const remarks = this.modalForm.get('remarks')?.value || '';
    this.charCount = remarks.length; // Count characters instead of words
    if (this.charCount > 300) {
      remarksControl?.setErrors({ charLimitExceeded: true });
    }else {
      remarksControl?.setErrors(null);
    }
    this.cdr.markForCheck();
  }
 resetRemarks(): void {
    this.modalForm.get('remarks')?.reset();
    //this.wordCount = 0;
    this.charCount = 0;
    this.cdr.markForCheck();
  }

  async onSiteImageChange(event: Event): Promise<void>{
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      // const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      // if (!validTypes.includes(file.type)) {
      //   this.siteSpecificationForm.get('siteImage')?.setErrors({ invalidType: 'Only JPG and PNG files are allowed.' });
      //   this.tempSiteImage = null;
      //   this.tempSiteImagePreview = null;
      //   return;
      // }

      if (!this.validateFile(file, /\.(jpg|jpeg|png)$/)) {
        this.notifyService.showWarning('Image must be a .jpg, .jpeg, or .png file', 'Validation Error');
        this.tempSiteImage = null;
        this.tempSiteImagePreview = null;
        this.tempSiteImageCoordinates = null;
      }else{
        const isGeotagged = await this.isGeoTagImage(file);
        if (isGeotagged) {
          ////console.log("isGeoTagImage - Site Image");
          this.tempSiteImage = file;
          this.tempSiteImageCoordinates = this.geoTagImgCoord;

          // Generate the image preview and wait for it to complete
          await new Promise<void>((resolve) => {
            this.readImageFile(file, (preview) => {
              this.tempSiteImagePreview = preview;
              resolve();
            });
          });
         this.addSiteImage();
          // Show notification after preview is set
          this.notifyService.showSuccess('Image is GeoTagged', 'Success');
        }else {
          this.notifyService.showWarning('Image is not GeoTagged', 'Validation Error');
          this.tempSiteImage = null;
          this.tempSiteImagePreview = null;
          this.tempSiteImageCoordinates = null;
        }
      }
    }else {
      this.tempSiteImage = null;
      this.tempSiteImagePreview = null;
      this.tempSiteImageCoordinates = null;
    }
    //this.cdr.markForCheck();
    const fileInput = document.getElementById('siteImage') as HTMLInputElement;
    if (fileInput) fileInput.value = ''; // Reset file input
  }
  addSiteImage(): void {
    if (this.tempSiteImage && this.tempSiteImagePreview && this.tempSiteImageCoordinates) {
          this.siteImages.push({
            file: this.tempSiteImage,
            previewUrl: this.tempSiteImagePreview,
            coordinates: this.tempSiteImageCoordinates
          });
      this.tempSiteImage = null;
      this.tempSiteImagePreview = null;
      this.tempSiteImageCoordinates = null;
     
      const input = document.getElementById('siteImage') as HTMLInputElement;
      if (input) input.value = ''; // Reset file input
      this.cdr.detectChanges();
    }
  }
  removeSiteImage(index: number): void {
    const image = this.siteImages[index];
    if (image.previewUrl) {
      URL.revokeObjectURL(image.previewUrl);
    }
    this.siteImages.splice(index, 1);
    
    const file=this.filesList[index];
    this.filesList.splice(file,1);

    this.cdr.detectChanges();
   
  }
  onSupportiveDocumentChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!validTypes.includes(file.type)) {
        this.siteSpecificationForm.get('supportiveDocument')?.setErrors({ invalidType: 'Only PDF, DOC, and DOCX files are allowed.' });
        this.supportiveDocumentPreviewUrl = null;
        return;
      }else{
        this.supportiveDocumentFile = file;
       if (this.supportiveDocumentBlobUrl) {
        URL.revokeObjectURL(this.supportiveDocumentBlobUrl);
      }
        const url = URL.createObjectURL(file);
       this.supportiveDocumentBlobUrl = URL.createObjectURL(file);
       this.supportiveDocumentPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.supportiveDocumentBlobUrl);
      }

      //this.siteSpecificationForm.get('supportiveDocument')?.setValue(file);
      // const reader = new FileReader();
      // reader.onload = () => {
      //   this.supportiveDocumentPreviewUrl = reader.result as string;
      //   this.cdr.detectChanges();
      // };
      // reader.readAsDataURL(file);
    }
  }
  unloadSupportiveDocument(): void {
    this.siteSpecificationForm.get('supportiveDocument')?.reset();
    this.supportiveDocumentPreviewUrl = null;
        this.supportiveDocumentBlobUrl=null;
    this.supportiveDocumentFile=null;
    const input = document.getElementById('supportiveDocument') as HTMLInputElement;
    if (input) input.value = '';
    this.cdr.detectChanges();
  }
  saveSiteSpecification(): void {

    if (!this.selectedRow || this.selectedRow.editableIndex === undefined) {
      this.notifyService.showError('No active row selected', 'Error');
      return;
    }

    if (this.selectedRow.isSaved) {
      this.notifyService.showWarning('Cannot save additional information while row is in edit mode', 'Warning');
      return;
    }


     const mapId = this.selectedRow.mapId;
    const siteImageLists=[];
      this.siteImages.forEach((image, index) => {
        siteImageLists.push(image.file);
         
        
        const originalName = image.file.name;
        const ext = this.getFileExtension(originalName);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));

        const newFileName = `${nameWithoutExt}_${mapId}${ext}`;

        image.file = new File(
          [image.file],      // file content
          newFileName,                 // new file name
          { type: image.file.type } // preserve type
        );
         this.filesList.push(image.file);
      });
      if(this.supportiveDocumentFile){
        const originalName = this.supportiveDocumentFile.name;
        const ext = this.getFileExtension(originalName);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));

        const newFileName = `${nameWithoutExt}_${mapId}${ext}`;

        this.supportiveDocumentFile = new File(
          [this.supportiveDocumentFile],      // file content
          newFileName,                 // new file name
          { type: this.supportiveDocumentFile.type } // preserve type
        );
         this.filesList.push(this.supportiveDocumentFile);
        this.filesList.push(this.supportiveDocumentFile);
      }
    this.selectedRow.siteSpecification = {
      remarks: this.siteSpecificationForm.get('remarks')?.value ? this.siteSpecificationForm.get('remarks')?.value : '',
      geoTagImages: siteImageLists? siteImageLists : null,
      supportiveDocumentFile:    this.supportiveDocumentFile  ? { name:  this.supportiveDocumentFile.name, size:  this.supportiveDocumentFile.size, type:  this.supportiveDocumentFile.type } : null
    };
     
    ////console.log(this.selectedRow.siteSpecification);

    this.notifyService.showSuccess('Site Specification  saved successfully', 'Success');
    this.closeSiteSpecificationModal();
    //this.cdr.markForCheck();
  }

//********** Additional Modal /Site SPecification ******************************************************** */
  openModal(row: TableRow) {
    if (row.editableIndex === undefined) {
      return;
    }
    if(!row.isSaved){
      this.notifyService.showWarning("Please Save Row before Site Specification","Warning")
      return;
    }
    ////console.log(row.additionalInfo)
    this.selectedRow = row;
    this.isModalOpen = true;
    this.sites = [];
    this.resetModalForm();
    //this.cdr.markForCheck();
  }
  closeModal() {
    if(this.sites.length >0 || this.apoSiteRemarksList.length> 0){
     Swal.fire({
      title: 'Are you sure?',
      text: 'You have not subbmited any sites . Are you sure you want to leave?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        this.isModalOpen = false;
          this.selectedRow = null;
          this.sites = [];
          this.resetModalForm();
          //this.cdr.markForCheck();
        
      }else{
        return;
      }
    });
    }else{
       this.isModalOpen = false;
          this.selectedRow = null;
          this.sites = [];
          this.resetModalForm();
    }
   
    
  }
  resetModalForm(){
     this.modalForm.reset();
     // Clear the sites list

    this.unloadAfterImage();
    this.unloadBeforeImage();
    this.unloadPdfFile();

    this.kmlFile=null;
    this.beforeImageFile=null;
    this.beforeImagePreview = null;
    this.afterImageFile=null;
    this.afterImagePreview = null;
    this.geoTagBeforeImgCoord = null;
    this.geoTagAfterImgCoord = null;
    this.pdfFile=null;
    this.pdfPreviewUrl = null;
    this.geojsonstring=null;
    this.geojsonprops=null;

  }
private validateFile(file: File, allowedExtensions: RegExp): boolean {
  return allowedExtensions.test(file.name.toLowerCase());
}
onKmlFileChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    if (!this.validateFile(file, /\.kml$/)) {
      this.modalForm.get('kmlFile')?.setErrors({ invalidType: 'Geography file must be a .kml file' });
      this.notifyService.showWarning('Geography file must be a .kml file', 'Validation Error');
      this.modalForm.get('kmlFile')?.setValue(null);
    } else {

      this.modalForm.get('kmlFile')?.setErrors(null);
      //this.modalForm.get('kmlFile')?.setValue(file);
      //this.modalForm.patchValue({ kmlFile: file });
   // this.modalForm.get('kmlFile')?.setValue(input.files[0]);
      // this.modalForm.patchValue({ kmlFile:  input.files[0] });

      this.kmlFile = file;

       var reader = new FileReader();
        let _this = this;
        reader.onload = function (e: any) {
          fetch(e.target.result)
            .then(function (response) {
              return response.text();
            })
            .then(function (xml) {
              const geoJsonObj = kml(
                new DOMParser().parseFromString(xml, 'text/xml')
              );
                const ageom = geoJsonObj['features'][0]['geometry'];
               _this.geojsonstring = JSON.stringify(ageom);
                ////console.log(' Geojson string:', _this.geojsonstring);

              // ✅ Log AFTER everything is done
              const properties = geoJsonObj['features'][0]['properties'];
              _this.geojsonprops = JSON.stringify(properties);
              ////console.log(' Geojson properties:', _this.geojsonprops);
            });
        };
        reader.readAsDataURL(file);
      
    }
  } else {
    this.modalForm.get('kmlFile')?.setValue(null);
    this.modalForm.get('kmlFile')?.setErrors(null);
  }
  //this.cdr.markForCheck();
}
unloadKMLFile(){
  this.modalForm.get('kmlFile')?.setValue(null);
  this.kmlFile=null;
}
async onBeforeImageChange(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (!this.validateFile(file, /\.(jpg|jpeg|png)$/)) {
      this.modalForm.get('beforeImage')?.setErrors({ invalidType: 'Before Image must be a .jpg, .jpeg, or .png file' });
      this.notifyService.showWarning('Before Image must be a .jpg, .jpeg, or .png file', 'Validation Error');
      this.modalForm.get('beforeImage')?.setValue(null);
      this.beforeImagePreview = null;
    } else {
      const isGeotagged = await this.isGeoTagImage(file); // Single API call, properly awaited
      if (isGeotagged) {
        ////console.log("isGeoTagImage - Before Image");
        this.beforeImageFile = file;
        this.geoTagBeforeImgCoord = this.geoTagImgCoord; // Reuse stored coordinates

        // Generate the image preview and wait for it to complete
        await new Promise<void>((resolve) => {
          this.readImageFile(file, (preview) => {
            this.beforeImagePreview = preview;
            resolve();
          });
        });

        // Show notification after preview is set
        this.notifyService.showSuccess('Before Image is GeoTag', 'Success');
        this.modalForm.get('beforeImage')?.setErrors(null);
        this.cdr.markForCheck();
      } else {
        this.notifyService.showWarning('Before Image is not GeoTag', 'Validation Error');
        this.modalForm.get('beforeImage')?.setValue(null);
        this.beforeImagePreview = null;
      }
    }
  } else {
    this.modalForm.get('beforeImage')?.setValue(null);
    this.modalForm.get('beforeImage')?.setErrors(null);
    this.beforeImageFile = null;
    if (this.beforeImagePreview) {
      URL.revokeObjectURL(this.beforeImagePreview);
      this.beforeImagePreview = null;
    }
  }
  //this.cdr.markForCheck();
}
async isGeoTagImage(selectedImgFiles: File): Promise<boolean> {
  let formData: FormData = new FormData();
  formData.append('file', selectedImgFiles);

  try {
    const response: any = await this.apiService
      .request('POST', 'api/v1/APO/getLatLongFromGeotaggedImage', formData)
      .toPromise(); // Convert Observable to Promise for proper async/await

    ////console.log('isGeoTagImage response:', response);
    if (response && response.status === 1) {
      this.geoTagImgCoord = response.data; // Store coordinates for reuse
      return true;
    } else {
      this.geoTagImgCoord = undefined; // Clear coordinates if not geotagged
      return false;
    }
  } catch (err) {
    console.error('Error in isGeoTagImage:', err);
    this.geoTagImgCoord = undefined; // Clear coordinates on error
    return false;
  }
}
unloadBeforeImage(){
  this.modalForm.get('beforeImage')?.setValue(null);
  this.modalForm.get('beforeImage')?.setErrors(null);
  this.geoTagImgCoord=undefined;
   this.geoTagBeforeImgCoord=undefined;
  // Clean up image previews
    if (this.beforeImagePreview) {
      URL.revokeObjectURL(this.beforeImagePreview);
      this.beforeImagePreview = null;
    }
     this.cdr.markForCheck();
}
async onAfterImageChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    if (!this.validateFile(file, /\.(jpg|jpeg|png)$/)) {
      this.modalForm.get('afterImage')?.setErrors({ invalidType: 'After Image must be a .jpg, .jpeg, or .png file' });
      this.notifyService.showWarning('After Image must be a .jpg, .jpeg, or .png file', 'Validation Error');
      this.modalForm.get('afterImage')?.setValue(null);
      this.afterImagePreview = null;
    } else {
      const isGeotagged = await this.isGeoTagImage(file); // Single API call, properly awaited
      if (isGeotagged) {
        this.afterImageFile = file;
        this.geoTagAfterImgCoord = this.geoTagImgCoord; // Reuse stored coordinates

        // Generate the image preview and wait for it to complete
        await new Promise<void>((resolve) => {
          this.readImageFile(file, (preview) => {
            this.afterImagePreview = preview;
            resolve();
          });
        });

        // Show notification after preview is set
        this.notifyService.showSuccess('After Image is GeoTag', 'Success');
        this.modalForm.get('afterImage')?.setErrors(null);
         this.cdr.markForCheck();
      } else {
        this.notifyService.showWarning('After Image is not Geo Tag file', 'Validation Error');
        this.modalForm.get('afterImage')?.setValue(null);
        this.afterImagePreview = null;
      }
    }
  } else {
    this.modalForm.get('afterImage')?.setValue(null);
    this.modalForm.get('afterImage')?.setErrors(null);
    this.afterImageFile = null;
    if (this.afterImagePreview) {
      URL.revokeObjectURL(this.afterImagePreview);
      this.afterImagePreview = null;
    }
  }
  //this.cdr.markForCheck();
}
unloadAfterImage(){
 this.modalForm.get('afterImage')?.setValue(null);
    this.modalForm.get('afterImage')?.setErrors(null);
  this.geoTagImgCoord=undefined;
   this.geoTagAfterImgCoord=undefined;
    if (this.afterImagePreview) {
      URL.revokeObjectURL(this.afterImagePreview);
      this.afterImagePreview = null;
    }
     this.cdr.markForCheck();
}
readImageFile(file: File, callback: (result: string | null) => void) {
    const reader = new FileReader();
    reader.onload = e => callback(reader.result as string);
    reader.readAsDataURL(file);
}
onPdfFileChange(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    if (!this.validateFile(file, /\.pdf$/)) {
      this.modalForm.get('pdfFile')?.setErrors({ invalidType: 'Supportive Document must be a .pdf file' });
      this.notifyService.showWarning('Supportive Document must be a .pdf file', 'Validation Error');
      this.modalForm.get('pdfFile')?.setValue(null);
    } else {
      
       this.modalForm.get('pdfFile')?.setErrors(null);
       this.pdfFile = file;
       ////console.log(this.pdfFile);
      //this.modalForm.get('pdfFile')?.setValue(file);

       if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
      }
        const url = URL.createObjectURL(file);
       this.pdfBlobUrl = URL.createObjectURL(file);
       this.pdfPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfBlobUrl);
        this.cdr.markForCheck();
      ////console.log(this.pdfPreviewUrl);
    }
  } else {
    this.modalForm.get('pdfFile')?.setValue(null);
    this.modalForm.get('pdfFile')?.setErrors(null);

    if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
        this.pdfPreviewUrl = null;
      }
  }
  //this.cdr.markForCheck();
}
unloadPdfFile(){
    // Clean up PDF preview URL
    if (this.pdfBlobUrl) {
      URL.revokeObjectURL(this.pdfBlobUrl);
      this.pdfPreviewUrl = null;
    }
     this.cdr.markForCheck();
}
saveAllSiteInfo() {
    // if (!this.selectedRow || this.selectedRow.editableIndex === undefined) {
    //   this.notifyService.showError('No active row selected', 'Error');
    //   return;
    // }

    // if (this.selectedRow.isSaved) {
    //   this.notifyService.showWarning('Cannot save additional information while row is in edit mode', 'Warning');
    //   return;
    // }

    //  // Check for any validation errors in form controls
    //  const fileErrors: string[] = [];
    //  ['kmlFile', 'beforeImage', 'afterImage', 'pdfFile'].forEach(controlName => {
    //    const control = this.modalForm.get(controlName);
    //    if (control?.errors?.['invalidType']) {
    //      fileErrors.push(control.errors['invalidType']);
    //    }
    //  });
 
    //  if (fileErrors.length > 0) {
    //    this.notifyService.showWarning(fileErrors.join('; '), 'Validation Error');
    //    return;
    //  }

    // //  const formValue = this.modalForm.value;
    // //  //console.log(formValue);
    //  this.selectedRow.additionalInfo = {
    //   geoJsonString:this.geojsonstring?this.geojsonstring:null,
    //   geoJsonProperties:this.geojsonprops?this.geojsonprops:null,
    //   kmlFile: this.kmlFile ? { name:  this.kmlFile.name, size:  this.kmlFile.size, type:  this.kmlFile.type } : null,
    //   beforeImage: this.beforeImageFile ? { name:  this.beforeImageFile.name, size:  this.beforeImageFile.size, type:  this.beforeImageFile.type } : null,
    //   beforeImageLatitude:this.geoTagBeforeImgCoord?.latitude,
    //   beforeImageLongitude: this.geoTagBeforeImgCoord?.longitude,
    //   afterImage: this.afterImageFile ? { name: this.afterImageFile.name, size: this.afterImageFile.size, type: this.afterImageFile.type } : null,
    //   afterImageLatitude:this.geoTagAfterImgCoord?.latitude,
    //   afterImageLongitude:this.geoTagAfterImgCoord?.longitude,
    //   pdfFile:  this.pdfFile  ? { name:  this.pdfFile.name, size:  this.pdfFile.size, type:  this.pdfFile.type } : null
    // };

   if(this.sites.length==0 || this.apoSiteRemarksList.length==0){
    this.notifyService.showWarning("No Site to Submit.","Warning");
    return;
   }
      if((this.selectedRow?.data['unitDD'] == '3' || this.selectedRow?.data['unitPrev'] == '3' || this.selectedRow?.data['unitCurr'] == '3') 
        && (Number(this.selectedRow?.data['quantity'] || this.selectedRow?.data['physicalTarget'] || this.selectedRow?.data['physicalTargetPrev'] || this.selectedRow?.data['physicalTargetCurr'] )- (this.selectedRow.siteSpecifictaionCount) || 0) > 0 && this.sites.length < Number(Number(this.selectedRow?.data['quantity'] || this.selectedRow?.data['physicalTarget'] || this.selectedRow?.data['physicalTargetPrev'] || this.selectedRow?.data['physicalTargetCurr'] )- (this.selectedRow.siteSpecifictaionCount) || 0)){
    this.notifyService.showWarning("Add More Sites.","Warning");
    return;
   }
   
    const mapId = this.selectedRow?.mapId || 0;
    const typeId = this.selectedRow?.typeId || null;
    const taskId = this.selectedRow?.taskId ;

    // Update matching row in tableData
    this.tableData.forEach(row => {
      if (row.mapId === mapId && row.taskId === taskId && row.typeId == typeId) {
          row.siteSpecifictaionCount= row.siteSpecifictaionCount+this.sites.length; 
      }
    });
   ////console.log("in insitesprcifification save",this.isErrorInSitesSubmitted);


   if(this.filesList.length>0){
        const apoSiteDocumentRequest = [];
        this.sites.forEach(site => {
          // Collect each file type with corresponding documentTypeId
          const files = [
            { file: site.kmlFile, typeId: 1 },
            { file: site.afterImage, typeId: 3 },
            { file: site.beforeImage, typeId: 2 },
            { file: site.pdfFile, typeId: 10 }
          ];

          files.forEach(fileEntry => {
            if (fileEntry.file) {
              apoSiteDocumentRequest.push({
                mapId: site.mapId,
                typeId: site.typeId,
                documentTypeId: fileEntry.typeId,
                documentName: fileEntry.file.name,
                extension: this.getFileExtension(fileEntry.file.name),
                docFor: 'apo_sites',
                latitude: (fileEntry.typeId==2 || fileEntry.typeId==3)?site.geoTagBeforeImgCoord?.latitude : null,
                longitude: (fileEntry.typeId==2 || fileEntry.typeId==3) ?site.geoTagBeforeImgCoord?.longitude : null,
                geoJson: fileEntry.typeId==1? site.geojsonstring:null,
                geoJsonProperties: fileEntry.typeId==1? site.geoJsonProperties :null
              });
            }
          });
        });

       
    
   // Prepare FormData for backend
    const formData = new FormData();
    formData.append('apoSiteDocumentRequest', JSON.stringify(apoSiteDocumentRequest))
    formData.append('userId', this.userid);
    ////console.log(this.filesList);
    this.filesList.forEach((file: File) => {
      formData.append('files', file); // Same key for each file
    });
    ////console.log(formData);

    this.apiService.request('POST', 'api/v1/APO/saveAllAPODocument', formData).subscribe({
      next: (data:any) =>{
        ////console.log(data);
        if(data.status==1){
           this.apoSiteIdList.push(...data.data);
           this.resetModalForm();
  
            this.notifyService.showSuccess('Site SPecification Document Upload successfully', 'Success');
            this.sites = [];
            this.filesList = [];
            this.isModalOpen = false;
            this.selectedRow = null;
            this.resetModalForm();
            this.cdr.markForCheck();
        }else{
          this.notifyService.showError('Unsuccessfull', 'Error');
        }
      },
      error: (error:any) =>{
         ////console.log(error);
         this.notifyService.showError('Failed to submit form data', 'Error');
      }
    });
   }else{
      this.resetModalForm();
       this.sites = [];
      this.closeModal();
   }

   ////console.log("Insavesite",this.tableData)

    this.resetModalForm();
    this.sites = [];
    this.isModalOpen = false;
    this.selectedRow = null;
    this.cdr.markForCheck();
}
getFileExtension(fileName: string): string {
  return fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
}
//******************************************************************************** */
  // Add site data to the sites array
  addSite(): void {
    // if (this.modalForm.invalid) {
    //   this.modalForm.markAllAsTouched();
    //   this.notifyService.showWarning('Please fill all required fields.', 'Warning');
    //   return;
    // }
     ////console.log(this.selectedRow);

    if ( this.selectedRow.islandBased && this.kmlFile==null) {
        this.notifyService.showWarning('KML file is Mandatory for Land Based Activity.', 'Warning');
        return;
      }

    const mapId = this.selectedRow?.mapId;
    const typeId=this.selectedRow?.typeId || null;
    const taskId = this.selectedRow?.taskId;

    if(this.kmlFile)
    {
         const originalName = this.kmlFile.name;
        const ext = this.getFileExtension(originalName);
        const random=Math.floor(10000 + Math.random() * 90000);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));

        const newFileName = `${nameWithoutExt}_${mapId}_kml_${random}${ext}`;

        this.kmlFile = new File(
          [this.kmlFile],      // file content
          newFileName,                 // new file name
          { type: this.kmlFile.type } // preserve type
        );
       this.filesList.push(this.kmlFile);

        // Update matching row in tableData
        this.tableData.forEach(row => {
          if (row.mapId === mapId && row.taskId === taskId && row.typeId == typeId) {
              row.isGeometryUploaded=true;
          }
        });
       
    }
     
    if(this.beforeImageFile)
    {
      const originalName = this.beforeImageFile.name;
        const ext = this.getFileExtension(originalName);
        const random=Math.floor(10000 + Math.random() * 90000);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));

        const newFileName = `${nameWithoutExt}_${mapId}_before_${random}${ext}`;

        this.beforeImageFile = new File(
          [this.beforeImageFile],      // file content
          newFileName,                 // new file name
          { type: this.beforeImageFile.type } // preserve type
        );
       this.filesList.push(this.beforeImageFile);
        ////console.log( this.filesList);
    }
     
    if(this.afterImageFile)
    {
        const originalName = this.afterImageFile.name;
        const ext = this.getFileExtension(originalName);
         const random=Math.floor(10000 + Math.random() * 90000);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));
        const newFileName = `${nameWithoutExt}_${mapId}_after_${random}${ext}`;

        this.afterImageFile = new File(
          [this.afterImageFile],      // file content
          newFileName,                 // new file name
          { type: this.afterImageFile.type } // preserve type
        );
       this.filesList.push(this.afterImageFile);
        ////console.log( this.filesList);
    }
      
    if(this.pdfFile)
    {
       const originalName = this.pdfFile.name;
        const ext = this.getFileExtension(originalName);
        const random=Math.floor(10000 + Math.random() * 90000);
        const nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));
        const newFileName = `${nameWithoutExt}_${mapId}_${random}${ext}`;

        this.pdfFile = new File(
          [this.pdfFile],      // file content
          newFileName,                 // new file name
          { type: this.pdfFile.type } // preserve type
        );
       this.filesList.push(this.pdfFile);
        ////console.log( this.filesList);
    }

    const siteData: SiteData = {
      mapId:mapId,
      typeId:typeId,
      remarks: this.modalForm.get('remarks')?.value,
      kmlFile: this.kmlFile,
      beforeImage: this.beforeImageFile,
      afterImage: this.afterImageFile,
      pdfFile: this.pdfFile,
      beforeImagePreview: this.beforeImagePreview,
      afterImagePreview: this.afterImagePreview,
      geoTagBeforeImgCoord: this.geoTagBeforeImgCoord,
      geoTagAfterImgCoord: this.geoTagAfterImgCoord,
      pdfPreviewUrl: this.pdfPreviewUrl,
      pdfBlobUrl:this.pdfBlobUrl,
      geojsonstring: this.geojsonstring,
      geoJsonProperties:this.geojsonprops
    };
    if(this.modalForm.get('remarks')?.value!=""){
     this.apoSiteRemarksList.push({
      mapId:mapId,
      typeId:typeId,
      siteRemarks: this.modalForm.get('remarks')?.value,
     });
    }
    
   // //console.log("siteData",siteData);
    this.sites.push(siteData);
    // //console.log("sites List",this.sites);
    // //console.log("apoSiteRemarksList", this.apoSiteRemarksList);

    // Reset form and previews
   this.resetModalForm();

    this.notifyService.showSuccess('Site added successfully!', 'Success');
    this.cdr.markForCheck();
  }

  // Remove a site from the list
  removeSite(index: number): void {
    this.sites.splice(index, 1);
    this.apoSiteRemarksList.splice(index,1);
    ////this.selectedRow.siteSpecifictaionCount=this.selectedRow.siteSpecifictaionCount-1;
    this.notifyService.showSuccess('Site removed successfully!', 'Success');
    this.cdr.markForCheck();
  }
//***************************************************** */
  getIndentPadding(row: TableRow): string {
    // Calculate padding based on hierarchy level
    return `${row.level}rem`;
  }

  cleanItemName(itemName: string): string {
    if (!itemName) return '';
    
    // Convert markdown-style formatting to HTML
    let cleaned = itemName
      .replace(/\*\*(.*?)\*\*/g, '$1')
      .replace(/\*(.*?)\*/g, '$1')
      .replace(/_(.*?)_/g, '$1');
      
    return cleaned;
  }
  toRoman(num: number): string {
    const romanNumerals = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x', 'xi', 'xii', 'xiii', 'xiv', 'xv', 'xvi', 'xvii', 'xviii', 'xix', 'xx'];
    return romanNumerals[num - 1] || num.toString();
  }
  trackByIndex(index: number, item: any): number {
    return index;
  }
  shouldShowEditableField(row: TableRow): boolean {
    return row.editableIndex !== undefined  && !row.hasChildren;
  }

  showFieldError(row: TableRow, fieldName: string): boolean {
    return !!row.errors[fieldName];
  }

  getFieldError(row: TableRow, fieldName: string): string {
    return row.errors[fieldName] || '';
  }

  onFieldBlur(fieldName: string, row: TableRow) {
     if (row.editableIndex !== undefined && row.isSaved) {
      return;
    }
    this.validateField(row, fieldName);
    this.cdr.markForCheck();
  }
  //********************************************* */

  saveRow(row: TableRow) {
    if (row.editableIndex === undefined) {
      return;
    }

   if(row.islandBased && Number(row.data['quantity'] || row.data['physicalTarget'] || row.data['physicalTargetPrev'] ||  row.data['physicalTargetCurr'] || '')>0  )
   {
     this.notifyService.showInfo("It is mandatory Upload KML in Site Specifications.","Info")
   }

  // Validate all editable fields
  let hasErrors = false;
  this.dynamicFields.forEach(field => {
    if (field.editable) {
      this.validateField(row, field.name);
      if (row.errors[field.name]) {
        hasErrors = true;
      }
    }
  });

  ////console.log(hasErrors)
  hasErrors=this.validateQuantity(row);

 ////console.log(hasErrors)
  
  // GPS dependency check: If any GPS field has a value, all are required
  const gpsFields = ['gpsDD1', 'gpsMM1', 'gpsSS1', 'gpsDD2', 'gpsMM2', 'gpsSS2'];
  const gpsDD1 = row.data['gpsDD1'] || '';
  const gpsMM1 = row.data['gpsMM1'] || '';
  const gpsSS1 = row.data['gpsSS1'] || '';
  const gpsDD2 = row.data['gpsDD2'] || '';
  const gpsMM2 = row.data['gpsMM2'] || '';
  const gpsSS2 = row.data['gpsSS2'] || '';

  // Check if any GPS field has a value
  const anyGpsFieldFilled = gpsDD1 || gpsMM1 || gpsSS1 || gpsDD2 || gpsMM2 || gpsSS2;

  // If any GPS field has a value, all GPS fields are required
  if (anyGpsFieldFilled) {
    if (!gpsDD1) {
      row.errors['gpsDD1'] = 'Latitude DD is required when any GPS coordinate is provided';
      hasErrors = true;
    }
    if (!gpsMM1) {
      row.errors['gpsMM1'] = 'Latitude MM is required when any GPS coordinate is provided';
      hasErrors = true;
    }
    if (!gpsSS1) {
      row.errors['gpsSS1'] = 'Latitude SS is required when any GPS coordinate is provided';
      hasErrors = true;
    }
    if (!gpsDD2) {
      row.errors['gpsDD2'] = 'Longitude DD is required when any GPS coordinate is provided';
      hasErrors = true;
    }
    if (!gpsMM2) {
      row.errors['gpsMM2'] = 'Longitude MM is required when any GPS coordinate is provided';
      hasErrors = true;
    }
    if (!gpsSS2) {
      row.errors['gpsSS2'] = 'Longitude SS is required when any GPS coordinate is provided';
      hasErrors = true;
    }
  } else {
    // If no GPS fields have values, clear any existing GPS errors
    gpsFields.forEach(gpsField => {
      row.errors[gpsField] = '';
    });
  }

  if (hasErrors) {
    this.notifyService.showWarning('Please fix the validation errors in the row', 'Warning');
    return;
  }
  // //console.log(row)

    row.isSaved = true;
    this.checkAllRowsSaved();
    this.cdr.markForCheck();
  }
  private checkAllRowsSaved(): void {
    this.allRowsSaved = this.tableData
      .filter(row => row.editableIndex !== undefined )
      .every(row => row.isSaved);
  }
  private hasSavedRows(): boolean {
    return this.tableData
      .filter(row => row.editableIndex !== undefined )
      .some(row => row.isSaved);
  }
  editRow(row: TableRow) {
    if (row.editableIndex === undefined) {
      return;
    }

    row.isSaved = false;
    this.checkAllRowsSaved();
    this.cdr.markForCheck();
  }

  resetRow(row: TableRow) {
    const isEditable = row.editableIndex !== undefined;
    if (!isEditable) {
      this.notifyService.showWarning('This row is not editable and cannot be reset', 'Warning');
      return;
    }

    // const isConfirmed = window.confirm("Are you sure you want to reset this row? Data will be undone after reset.");
    // if (!isConfirmed) {
    //   this.notifyService.showInfo('Reset action canceled', 'Info');
    //   return;
    // }

              this.dynamicFields.forEach(field => {
            if (field.editable) {
              if (field.name === 'itemDD'  || field.name === 'quantity' || field.name === 'unitCost' || field.name==='amountRequired') {
                //default value as it is
                }else {
                    row.data[field.name] = field.type === 'text' ? '' : '';
                    row.errors[field.name] = '';
                }
            
            }
        });
      
      // Clear all errors
      row.errors = {};

// Reset additionalInfo
        row.additionalInfo = {
          geoJsonString:null,
          geoJsonProperties:null,
          kmlFile: null,
          beforeImage: null,
          beforeImageLatitude:null,
          beforeImageLongitude:null,
          afterImage: null,
          afterImageLatitude:null,
          afterImageLongitude:null,
          pdfFile: null
        };

        // Reset saved state
        row.isSaved = false;

        this.checkAllRowsSaved();
        this.notifyService.showSuccess('Row reset successfully', 'Success');


    // const editableRows = row.editableIndex !== undefined;
    // if (editableRows) {
    // // Show confirmation dialog and capture the response
    //  const isConfirmed = window.confirm("Are you sure you want to reset  rows? Data will be undone after reset.");
    //  if (isConfirmed) {
    //     // Reset editable fields in row.data
        // this.dynamicFields.forEach(field => {
        //     if (field.editable) {
        //       if (field.name === 'itemDD'  || field.name === 'quantity' || field.name === 'unitCost' || field.name==='amountRequired') {
        //         //default value as it is
        //         }else {
        //             row.data[field.name] = field.type === 'text' ? '' : '';
        //             row.errors[field.name] = '';
        //         }
            
        //     }
        // });

    //     // Reset additionalInfo
    //     row.additionalInfo = {
    //       geoJsonString:null,
    //       geoJsonProperties:null,
    //       kmlFile: null,
    //       beforeImage: null,
    //       beforeImageLatitude:null,
    //       beforeImageLongitude:null,
    //       afterImage: null,
    //       afterImageLatitude:null,
    //       afterImageLongitude:null,
    //       pdfFile: null
    //     };

    //     // Reset saved state
    //     row.isSaved = false;

    //     this.checkAllRowsSaved();
    //     this.notifyService.showSuccess('Row reset successfully', 'Success');
    //     //this.cdr.markForCheck();
    //   }
    // }else{
    //  this.notifyService.showWarning('No editable rows to reset', 'Warning');
    //   return;
    //  }
  }
  onFileChange(event: any, controlName: string) {
    const file = event.target.files[0];
    this.modalForm.get(controlName)?.setValue(file);
  }
  resetAllRows() {
    const editableRows = this.tableData.filter(row => row.editableIndex !== undefined);
    if (editableRows.length === 0) {
      this.notifyService.showWarning('No editable rows to reset', 'Warning');
      return;
    }
    // Show confirmation dialog and capture the response
  const isConfirmed = window.confirm("Are you sure you want to reset all rows? Data will be undone after reset.");
  
  if (isConfirmed) {
    // Proceed with reset only if user confirms
    editableRows.forEach(row => this.resetRow(row));
    this.notifyService.showSuccess('All rows reset successfully', 'Success');
    this.checkAllRowsSaved();
    // Uncomment if change detection is needed
    // this.cdr.markForCheck();
  } else {
    // Optionally notify the user that the action was canceled
   // this.notifyService.showInfo('Reset action canceled', 'Info');
  }
  }
  saveAllRows(){
    // Check if there are any rows to save
  //const unsavedRows = this.tableData.filter(row => row.editableIndex > 0 && !row.isSaved);

// Check if there are any rows to save
  const unsavedRows = this.tableData.filter(row => typeof row.editableIndex !== 'undefined' && row.editableIndex >= 0 && !row.isSaved);

  if (unsavedRows.length === 0) {
    this.notifyService.showInfo('No unsaved rows to submit', 'Info');
    return;
  }

    // Validate all unsaved rows
  let hasErrors = false;
  const gpsFields = ['gpsDD1', 'gpsMM1', 'gpsSS1', 'gpsDD2', 'gpsMM2', 'gpsSS2'];

  unsavedRows.forEach(row => {
    // Run standard validations for all fields
    this.dynamicFields.forEach(field => {
      if (field.editable) {
        this.validateField(row, field.name);
        if (row.errors[field.name]) {
          hasErrors = true;
        }
      }
    });

    // GPS dependency check: If any GPS field has a value, all are required
    const gpsDD1 = row.data['gpsDD1'] || '';
    const gpsMM1 = row.data['gpsMM1'] || '';
    const gpsSS1 = row.data['gpsSS1'] || '';
    const gpsDD2 = row.data['gpsDD2'] || '';
    const gpsMM2 = row.data['gpsMM2'] || '';
    const gpsSS2 = row.data['gpsSS2'] || '';

    // Check if any GPS field has a value
    const anyGpsFieldFilled = gpsDD1 || gpsMM1 || gpsSS1 || gpsDD2 || gpsMM2 || gpsSS2;

    // If any GPS field has a value, all GPS fields are required
    if (anyGpsFieldFilled) {
      if (!gpsDD1) {
        row.errors['gpsDD1'] = 'Latitude DD is required when any GPS coordinate is provided';
        hasErrors = true;
      }
      if (!gpsMM1) {
        row.errors['gpsMM1'] = 'Latitude MM is required when any GPS coordinate is provided';
        hasErrors = true;
      }
      if (!gpsSS1) {
        row.errors['gpsSS1'] = 'Latitude SS is required when any GPS coordinate is provided';
        hasErrors = true;
      }
      if (!gpsDD2) {
        row.errors['gpsDD2'] = 'Longitude DD is required when any GPS coordinate is provided';
        hasErrors = true;
      }
      if (!gpsMM2) {
        row.errors['gpsMM2'] = 'Longitude MM is required when any GPS coordinate is provided';
        hasErrors = true;
      }
      if (!gpsSS2) {
        row.errors['gpsSS2'] = 'Longitude SS is required when any GPS coordinate is provided';
        hasErrors = true;
      }
    } else {
      // If no GPS fields have values, clear any existing GPS errors
      gpsFields.forEach(gpsField => {
        row.errors[gpsField] = '';
      });
    }
  });




    // validateQuantity
  this.tableData.some((row) => {
       this.dynamicFields.forEach(field => {
      if (field.editable) {
        this.validateQuantity(row);
        if (row.errors[field.name]) {
          hasErrors = true;
        }
      }
    });
  });
//  //console.log("in savaeallrows",this.isErrorInSitesSubmitted);
this.tableData.some((row) => {
  this.dynamicFields.forEach(field => {
      if (field.editable) {
       
        if(row.islandBased && !row.isGeometryUploaded &&
          Number(row.data['quantity'] || row.data['physicalTarget'] ||  row.data['physicalTargetPrev'] ||  row.data['physicalTargetCurr'] || '')>0
           )  {
               this.notifyService.showError('Please Submit all Land Based Sites Specifications Data', 'Validation Error');
               hasErrors=true;
               return;
        }
      }
    });
  });

//   if (this.isErrorInSitesSubmitted) {
//     this.notifyService.showError('Please Submit all Land Based Sites Specifications Data', 'Validation Error');
//     return;
//   }


    

  if (hasErrors) {
    this.notifyService.showError('Please correct the errors in the form before saving all rows', 'Validation Error');
    return;
  }
  // Mark all unsaved rows as saved
      unsavedRows.forEach(row => {
        row.isSaved = true;
      });

      this.notifyService.showSuccess('All rows saved successfully', 'Success');
      this.checkAllRowsSaved();
  }
  public hasUnsavedChanges(): boolean {
  // If tableData and initialTableData have different lengths, something has changed
  if (this.tableData.length !== this.initialTableData.length) {
    return true;
  }

  // Compare each row
  return this.tableData.some((row, index) => {
    const initialRow = this.initialTableData[index];

    // Compare editable fields in row.data
    return this.dynamicFields.some(field => {
      if (field.editable && field.name !== 'amountRequired') { // Exclude calculated field
        const currentValue = row.data[field.name] || '';
        const initialValue = initialRow.data[field.name] || '';
        return currentValue !== initialValue;
      }
      return false;
    });
  });
 }
  submitData() {
    // Check for unsaved editable rows
    const hasUnsavedRows = this.tableData
      .filter(row => row.editableIndex !== undefined)
      .some(row => !row.isSaved);

    if (hasUnsavedRows) {
      this.notifyService.showWarning('Please save data before submitting', 'Warning');
      return;
    }

    if (!this.allRowsSaved) {
      this.notifyService.showWarning('Please select a scheme and component, and save all rows', 'Warning');
      return;
    }
    let _this=this;
   
    const rowData = this.tableData.map(row => {
      const mapId = row.mapId;
      const typeId=row.typeId;
      //console.log(row);

      //APO Data
      const values = {
        quantity: row.data.quantity || 0,
        unitCost: row.data.unitCost || 0,
        amountRequired: row.data.amountRequired || 0,
        location: row.data.location || '',
        gpsdd1: row.data.gpsDD1 || 0,
        gpsmm1: row.data.gpsMM1 || 0,
        gpsss1: row.data.gpsSS1 || 0,
        gpsdd2: row.data.gpsDD2 || 0,
        gpsmm2: row.data.gpsMM2 || 0,
        gpsss2: row.data.gpsSS2 || 0,
        paraDetails:row.data.paraDetails	 || '',
        physicalTarget : row.data.physicalTarget || 0,
        financialTarget : row.data.financialTarget || 0,
        unitKms : row.data.unitKms  || 0,
        amountINR : row.data.amountINR  || 0,

            unitDD:   row.data.unitDD?.toString() || '',
            paraNoTCP : row.data.paraNoTCP?.toString() || '',
            paraNoCSS  : row.data.paraNoCSS?.toString() || '',
            physicalTargetPrev : row.data.physicalTargetPrev?.toString() || '',
            unitPrev : row.data.unitPrev?.toString() || '',

           physicalAchievementPrev : row.data.physicalAchievementPrev?.toString() || '',
           financialTargetPrev : row.data.financialTargetPrev?.toString() || 0,
           financialAchievementPrev : row.data.financialAchievementPrev?.toString() ||0,
           physicalTargetCurr : row.data.physicalTargetCurr?.toString() || '',
           unitCurr : row.data.unitCurr?.toString() || '',
           unitCostCurr : row.data.unitCostCurr?.toString() || '',
           financialTargetCurr : row.data.financialTargetCurr?.toString() || 0,
      };

      //Additinal Info & Site Justification 
      ////console.log(row.additionalInfo);
       
      // if(row.siteSpecification){
      //   //console.log("in", row.siteSpecification);
      //   if (row.siteSpecification.remarks) {
      //      siteJustoficationDetails.push({
      //       mapId: mapId,
      //       siteRemarks:row.siteSpecification.remarks
      //      })
      //   }if (row.siteSpecification.geoTagImages){
      //     if(row.siteSpecification.geoTagImages.length>0){
      //       row.siteSpecification.geoTagImages.forEach(function(image) {
      //         documentDetails.push({
      //           mapId: mapId,
      //           documentTypeId: 11,
      //           documentName: image.name,
      //            extension: _this.getFileExtension(image.name),
      //             docFor: 'apo_sites',
      //             latitude: '',
      //             longitude: '',
      //             geoJson: '',
      //             geoJsonProperties: ''
      //         });
      //       });
      //     }
      //   }if (row.siteSpecification.supportiveDocumentFile){
      //         documentDetails.push({
      //             mapId: mapId,
      //             documentTypeId: 10,
      //             documentName: row.siteSpecification.supportiveDocumentFile.name,
      //             extension: _this.getFileExtension(row.siteSpecification.supportiveDocumentFile.name),
      //             docFor: 'apo_sites',
      //             latitude: '',
      //             longitude: '',
      //             geoJson: '',
      //             geoJsonProperties: ''
      //        });
      //   }
      // }
    
      return {
        mapId,
        typeId,
        ...values
      };
    }).filter(row => row !== null); // Remove null entries from skipped rows

    // if (rowData.length === 0) {
    //   this.notifyService.showWarning('No valid rows to submit', 'Warning');
    //   return;
    // }
   // //console.log(rowData);
    ////console.log('Generated JSON data:', JSON.stringify(rowData, null, 2));
    ////console.log('Remarks List :',this.apoSiteRemarksList);
    const componentId = parseInt(this.apoForm.get('component')?.value);

    // Prepare FormData for backend
    const formData = new FormData();
    formData.append('apoData', JSON.stringify(rowData));
    formData.append('apoSiteRemarks', JSON.stringify(this.apoSiteRemarksList));
    formData.append('apoSiteDocumentMap', JSON.stringify(this.apoSiteIdList))
    formData.append('userId', this.userid);
    formData.append('componentId', componentId.toString());
    
    ////console.log(formData);
    this.apiService.request('POST', 'api/v1/APO/saveAllAPOForm', formData).subscribe({
      next: (data:any) =>{
        ////console.log(data);
          if(data.status==1){
          this.notifyService.showSuccess(data.response, 'Success');
          this.previousSchemeId = '0';
          this.previousComponentId = '0';
          //Reset Form
          this.apoForm.reset();
          this.apoForm.get('scheme')?.setValue('0');
          this.apoForm.get('subscheme')?.setValue('0');
          this.apoForm.get('component')?.setValue('0');
          this.subSchemeList=[];
          this.componentList=[];

          this.tableData = [];
           this.initialTableData=[];
          this.checkAllRowsSaved();
          this.cdr.markForCheck();
        }else{
          this.notifyService.showError('Failed to submit form data', 'Error');
        }
      },error(err:any) {
        console.error(err);
           this.notifyService.showError('Failed to submit form data', 'Error');
      },
    });
  }
 

//****************************************************** */
togglePanel(panel: string): void {
  //this.openPanels = { view: false, execution: false, map: false };
  if(this.openPanels[panel]==true)
  {
    this.openPanels[panel] = false;
  }else{
    this.openPanels[panel] = true;
  }
     
  ////this.cdr.markForCheck();
}




setActiveTab(tab: string): void {
  this.activeTab = tab;
}

}